import React from 'react';
import clsx from 'clsx';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { mergeClasses } from '@material-ui/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    svg: {
      // height: '250px',
    },

    st0: { fill: '#034EA2' },
    st1: { fill: '#58595B' },
    st2: {
      fill: 'none',
      stroke: '#034EA2',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeDasharray: '0,2.987',
    },
    st3: { fill: 'none', stroke: '#034EA2', strokeLinecap: 'round', strokeLinejoin: 'round' },
    st4: {
      fill: 'none',
      stroke: '#034EA2',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeDasharray: '0,3.035',
    },
    st5: {
      fill: 'none',
      stroke: '#034EA2',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeDasharray: '0,3.002',
    },
    st6: {
      fill: 'none',
      stroke: '#034EA2',
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
      strokeDasharray: '0,3.157',
    },

    animation: {
      animationName: '$title',
      animationDuration: '3s',
    },
    animation2: {
      animationName: '$title',
      animationDuration: '2s',
    },
    animation3: {
      animationName: '$title',
      animationDuration: '2s',
    },

    '@keyframes title': {
      ...animationFunc(),
    },
  }),
);

function animationFunc() {
  return {
    '0%': { opacity: 0 },
    // '20%': { opacity: 0 },
    // '40%': { opacity: 0.3 },
    // '60%': { opacity: 0.5 },
    // '80%': { opacity: 0.9 },
    '100%': { opacity: 1 },
  };
}

const DriversOfHunger = () => {
  const classes = useStyles();

  const [ref, inView] = useInView({
    threshold: 0,
  });

  return (
    <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 361.89 204.22" ref={ref}>
      <g>
        <g>
          <path
            className={clsx(inView && classes.animation2, classes.st0)}
            d="M267.03,78.87l4.78-10.36h-6.29V66.8h8.36v1.36l-4.76,10.72H267.03z"
          />
          <path
            className={clsx(inView && classes.animation2, classes.st0)}
            d="M276.7,78.87l4.78-10.36h-6.29V66.8h8.36v1.36l-4.76,10.72H276.7z"
          />
        </g>
        <g>
          <path
            className={clsx(inView && classes.animation2, classes.st0)}
            d="M292.78,78.87l-3.51-10.1h-0.07c0.09,1.5,0.14,2.91,0.14,4.22v5.88h-1.79V66.78h2.79l3.36,9.62h0.05
			l3.46-9.62h2.8v12.09h-1.9v-5.98c0-0.6,0.01-1.38,0.04-2.35c0.03-0.96,0.06-1.55,0.08-1.75h-0.07l-3.63,10.08H292.78z"
          />
        </g>
        <g>
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M268.65,93.72l-0.14-0.69h-0.04c-0.24,0.3-0.48,0.51-0.72,0.61c-0.24,0.11-0.54,0.16-0.89,0.16
			c-0.48,0-0.85-0.12-1.12-0.37c-0.27-0.25-0.41-0.6-0.41-1.05c0-0.97,0.78-1.48,2.33-1.53l0.82-0.03v-0.3
			c0-0.38-0.08-0.66-0.24-0.84c-0.16-0.18-0.42-0.27-0.78-0.27c-0.4,0-0.86,0.12-1.36,0.37l-0.22-0.56c0.24-0.13,0.5-0.23,0.78-0.3
			c0.28-0.07,0.57-0.11,0.85-0.11c0.57,0,1,0.13,1.28,0.38c0.28,0.25,0.42,0.66,0.42,1.23v3.29H268.65z M267,93.21
			c0.45,0,0.81-0.12,1.07-0.37c0.26-0.25,0.39-0.6,0.39-1.05v-0.44l-0.73,0.03c-0.58,0.02-1,0.11-1.25,0.27
			c-0.26,0.16-0.38,0.41-0.38,0.74c0,0.26,0.08,0.46,0.24,0.6C266.49,93.14,266.71,93.21,267,93.21z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M272.62,93.81c-0.7,0-1.24-0.21-1.62-0.64c-0.38-0.43-0.57-1.04-0.57-1.82c0-0.81,0.19-1.43,0.58-1.87
			c0.39-0.44,0.94-0.66,1.66-0.66c0.23,0,0.46,0.02,0.69,0.07s0.41,0.11,0.54,0.18l-0.22,0.62c-0.16-0.06-0.34-0.12-0.53-0.16
			s-0.36-0.06-0.51-0.06c-0.98,0-1.47,0.62-1.47,1.87c0,0.59,0.12,1.05,0.36,1.36c0.24,0.32,0.59,0.47,1.06,0.47
			c0.4,0,0.81-0.09,1.23-0.26v0.65C273.51,93.72,273.11,93.81,272.62,93.81z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M275.66,88.9v3.12c0,0.39,0.09,0.69,0.27,0.88s0.46,0.29,0.84,0.29c0.5,0,0.87-0.14,1.11-0.41
			c0.23-0.28,0.35-0.73,0.35-1.35V88.9h0.73v4.82h-0.6l-0.11-0.65h-0.04c-0.15,0.24-0.36,0.42-0.62,0.54
			c-0.27,0.13-0.57,0.19-0.91,0.19c-0.59,0-1.03-0.14-1.32-0.42c-0.29-0.28-0.44-0.72-0.44-1.34V88.9H275.66z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M282.06,93.21c0.13,0,0.25-0.01,0.37-0.03c0.12-0.02,0.22-0.04,0.29-0.06v0.56c-0.08,0.04-0.2,0.07-0.35,0.09
			c-0.15,0.02-0.29,0.04-0.42,0.04c-0.93,0-1.4-0.49-1.4-1.47v-2.87h-0.69v-0.35l0.69-0.3l0.31-1.03h0.42v1.12h1.4v0.57h-1.4v2.83
			c0,0.29,0.07,0.51,0.21,0.67S281.82,93.21,282.06,93.21z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M285.71,93.81c-0.71,0-1.27-0.22-1.69-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6s0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.15,0.44c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24
			C286.32,93.78,286.04,93.81,285.71,93.81z M285.52,89.43c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C286.19,89.55,285.9,89.43,285.52,89.43z"
          />
          <path       className={clsx(inView && classes.animation, classes.st1)} d="M289.46,93.72h-0.73v-6.84h0.73V93.72z" />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M290.24,88.9h0.78l1.05,2.75c0.23,0.63,0.38,1.08,0.43,1.36h0.04c0.04-0.15,0.12-0.4,0.24-0.77
			c0.12-0.36,0.52-1.47,1.19-3.34h0.78l-2.07,5.48c-0.21,0.54-0.44,0.93-0.72,1.15c-0.27,0.23-0.61,0.34-1.01,0.34
			c-0.22,0-0.44-0.02-0.66-0.07v-0.58c0.16,0.04,0.34,0.05,0.54,0.05c0.5,0,0.86-0.28,1.07-0.84l0.27-0.69L290.24,88.9z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M300.05,89.47h-1.23v4.25h-0.73v-4.25h-0.86v-0.33l0.86-0.26v-0.27c0-1.18,0.52-1.78,1.55-1.78
			c0.25,0,0.55,0.05,0.9,0.15l-0.19,0.58c-0.28-0.09-0.52-0.14-0.72-0.14c-0.28,0-0.48,0.09-0.61,0.27c-0.13,0.18-0.2,0.48-0.2,0.88
			v0.31h1.23V89.47z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M305.08,91.31c0,0.79-0.2,1.4-0.59,1.84s-0.94,0.66-1.64,0.66c-0.43,0-0.81-0.1-1.15-0.3
			s-0.59-0.49-0.77-0.87s-0.27-0.82-0.27-1.33c0-0.79,0.2-1.4,0.59-1.83s0.94-0.66,1.63-0.66c0.67,0,1.21,0.22,1.61,0.67
			C304.89,89.94,305.08,90.54,305.08,91.31z M301.41,91.31c0,0.62,0.12,1.08,0.37,1.41s0.61,0.48,1.09,0.48s0.84-0.16,1.09-0.48
			c0.25-0.32,0.37-0.79,0.37-1.41c0-0.61-0.12-1.08-0.37-1.4c-0.25-0.32-0.61-0.48-1.1-0.48c-0.48,0-0.84,0.16-1.08,0.47
			S301.41,90.69,301.41,91.31z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M310.52,91.31c0,0.79-0.2,1.4-0.59,1.84s-0.94,0.66-1.64,0.66c-0.43,0-0.81-0.1-1.15-0.3
			s-0.59-0.49-0.77-0.87s-0.27-0.82-0.27-1.33c0-0.79,0.2-1.4,0.59-1.83s0.94-0.66,1.63-0.66c0.67,0,1.21,0.22,1.61,0.67
			C310.32,89.94,310.52,90.54,310.52,91.31z M306.85,91.31c0,0.62,0.12,1.08,0.37,1.41s0.61,0.48,1.08,0.48s0.84-0.16,1.09-0.48
			c0.25-0.32,0.37-0.79,0.37-1.41c0-0.61-0.12-1.08-0.37-1.4c-0.25-0.32-0.61-0.48-1.1-0.48c-0.48,0-0.84,0.16-1.08,0.47
			S306.85,90.69,306.85,91.31z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M315.08,93.07h-0.04c-0.34,0.49-0.84,0.73-1.51,0.73c-0.63,0-1.12-0.22-1.47-0.65
			c-0.35-0.43-0.53-1.04-0.53-1.84s0.18-1.41,0.53-1.85s0.84-0.66,1.47-0.66c0.65,0,1.15,0.24,1.5,0.71h0.06l-0.03-0.35l-0.02-0.34
			v-1.96h0.73v6.84h-0.59L315.08,93.07z M313.62,93.2c0.5,0,0.86-0.14,1.08-0.41c0.22-0.27,0.34-0.71,0.34-1.31v-0.15
			c0-0.68-0.11-1.17-0.34-1.46c-0.23-0.29-0.59-0.44-1.09-0.44c-0.43,0-0.76,0.17-0.98,0.5c-0.23,0.33-0.34,0.8-0.34,1.41
			c0,0.62,0.11,1.08,0.34,1.39S313.18,93.2,313.62,93.2z"
          />
          <path       className={clsx(inView && classes.animation, classes.st1)} d="M316.91,91.64v-0.67h2.16v0.67H316.91z" />
        </g>
        <g>
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M265.63,99.6c0-0.17,0.04-0.29,0.12-0.37s0.18-0.12,0.31-0.12c0.12,0,0.22,0.04,0.3,0.12s0.13,0.2,0.13,0.36
			s-0.04,0.29-0.13,0.37c-0.08,0.08-0.19,0.12-0.3,0.12c-0.12,0-0.23-0.04-0.31-0.12C265.67,99.88,265.63,99.76,265.63,99.6z
			 M266.42,105.72h-0.73v-4.82h0.73V105.72z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M271.26,105.72v-3.12c0-0.39-0.09-0.69-0.27-0.88s-0.46-0.29-0.84-0.29c-0.5,0-0.87,0.14-1.11,0.41
			s-0.35,0.72-0.35,1.35v2.53h-0.73v-4.82h0.59l0.12,0.66h0.04c0.15-0.24,0.36-0.42,0.63-0.55c0.27-0.13,0.57-0.2,0.9-0.2
			c0.58,0,1.02,0.14,1.31,0.42s0.44,0.73,0.44,1.34v3.14H271.26z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M276.59,104.4c0,0.45-0.17,0.79-0.5,1.04s-0.8,0.36-1.41,0.36c-0.64,0-1.14-0.1-1.49-0.3v-0.68
			c0.23,0.12,0.48,0.21,0.75,0.28c0.26,0.07,0.52,0.1,0.77,0.1c0.38,0,0.67-0.06,0.88-0.18s0.31-0.31,0.31-0.56
			c0-0.19-0.08-0.35-0.24-0.48c-0.16-0.13-0.48-0.29-0.95-0.47c-0.45-0.17-0.77-0.31-0.96-0.44c-0.19-0.12-0.33-0.27-0.42-0.42
			c-0.09-0.16-0.14-0.35-0.14-0.57c0-0.39,0.16-0.7,0.48-0.93s0.76-0.34,1.31-0.34c0.52,0,1.03,0.11,1.52,0.32l-0.26,0.59
			c-0.48-0.2-0.92-0.3-1.31-0.3c-0.35,0-0.61,0.05-0.78,0.16s-0.26,0.26-0.26,0.45c0,0.13,0.03,0.24,0.1,0.33
			c0.07,0.09,0.17,0.18,0.32,0.26s0.43,0.2,0.84,0.36c0.57,0.21,0.96,0.42,1.16,0.63C276.49,103.82,276.59,104.08,276.59,104.4z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M279.82,105.8c-0.71,0-1.27-0.22-1.69-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6s0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.15,0.44c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24
			C280.42,105.78,280.14,105.8,279.82,105.8z M279.62,101.42c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C280.29,101.55,280,101.42,279.62,101.42z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M284.76,105.8c-0.7,0-1.24-0.21-1.62-0.64c-0.38-0.43-0.57-1.04-0.57-1.82c0-0.81,0.19-1.43,0.58-1.87
			c0.39-0.44,0.94-0.66,1.66-0.66c0.23,0,0.46,0.02,0.69,0.07s0.41,0.11,0.54,0.18l-0.22,0.62c-0.16-0.06-0.34-0.12-0.53-0.16
			s-0.36-0.06-0.51-0.06c-0.98,0-1.47,0.62-1.47,1.87c0,0.59,0.12,1.05,0.36,1.36c0.24,0.32,0.59,0.47,1.06,0.47
			c0.4,0,0.81-0.09,1.23-0.26v0.65C285.65,105.72,285.24,105.8,284.76,105.8z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M287.8,100.9v3.12c0,0.39,0.09,0.69,0.27,0.88s0.46,0.29,0.84,0.29c0.5,0,0.87-0.14,1.11-0.41
			c0.23-0.28,0.35-0.73,0.35-1.35v-2.53h0.73v4.82h-0.6l-0.11-0.65h-0.04c-0.15,0.24-0.36,0.42-0.62,0.54
			c-0.27,0.13-0.57,0.19-0.91,0.19c-0.59,0-1.03-0.14-1.32-0.42c-0.29-0.28-0.44-0.72-0.44-1.34v-3.15H287.8z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M294.84,100.81c0.21,0,0.41,0.02,0.58,0.05l-0.1,0.68c-0.2-0.04-0.38-0.07-0.53-0.07
			c-0.39,0-0.72,0.16-1,0.47c-0.28,0.32-0.42,0.71-0.42,1.18v2.58h-0.73v-4.82h0.6l0.08,0.89h0.04c0.18-0.31,0.39-0.56,0.65-0.73
			S294.53,100.81,294.84,100.81z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M298.35,105.8c-0.71,0-1.27-0.22-1.68-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6s0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.14,0.44c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24
			C298.95,105.78,298.67,105.8,298.35,105.8z M298.15,101.42c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C298.82,101.55,298.53,101.42,298.15,101.42z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M305.94,105.8c-0.31,0-0.6-0.06-0.86-0.17c-0.26-0.12-0.48-0.29-0.65-0.53h-0.05
			c0.04,0.28,0.05,0.55,0.05,0.8v1.98h-0.73v-6.98h0.59l0.1,0.66h0.04c0.19-0.26,0.41-0.45,0.66-0.57s0.53-0.18,0.86-0.18
			c0.64,0,1.13,0.22,1.48,0.65c0.35,0.44,0.52,1.05,0.52,1.84c0,0.79-0.18,1.41-0.53,1.84C307.06,105.59,306.57,105.8,305.94,105.8z
			 M305.84,101.43c-0.49,0-0.85,0.14-1.07,0.41s-0.33,0.71-0.34,1.3v0.16c0,0.68,0.11,1.16,0.34,1.45s0.59,0.44,1.08,0.44
			c0.42,0,0.74-0.17,0.98-0.51c0.24-0.34,0.35-0.8,0.35-1.39c0-0.6-0.12-1.06-0.35-1.38C306.6,101.59,306.26,101.43,305.84,101.43z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M311.25,105.8c-0.71,0-1.27-0.22-1.68-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6s0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.14,0.44c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24
			C311.85,105.78,311.58,105.8,311.25,105.8z M311.05,101.42c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C311.73,101.55,311.43,101.42,311.05,101.42z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M318.42,103.3c0,0.79-0.2,1.4-0.59,1.84s-0.94,0.66-1.64,0.66c-0.43,0-0.81-0.1-1.15-0.3
			s-0.59-0.49-0.77-0.87s-0.27-0.82-0.27-1.33c0-0.79,0.2-1.4,0.59-1.83s0.94-0.66,1.63-0.66c0.67,0,1.21,0.22,1.61,0.67
			C318.22,101.93,318.42,102.54,318.42,103.3z M314.75,103.3c0,0.62,0.12,1.08,0.37,1.41s0.61,0.48,1.08,0.48s0.84-0.16,1.09-0.48
			c0.25-0.32,0.37-0.79,0.37-1.41c0-0.61-0.12-1.08-0.37-1.4c-0.25-0.32-0.61-0.48-1.1-0.48c-0.48,0-0.84,0.16-1.08,0.47
			S314.75,102.68,314.75,103.3z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M321.94,105.8c-0.31,0-0.6-0.06-0.86-0.17c-0.26-0.12-0.48-0.29-0.65-0.53h-0.05
			c0.04,0.28,0.05,0.55,0.05,0.8v1.98h-0.73v-6.98h0.59l0.1,0.66h0.04c0.19-0.26,0.41-0.45,0.65-0.57s0.54-0.18,0.86-0.18
			c0.64,0,1.13,0.22,1.48,0.65c0.35,0.44,0.52,1.05,0.52,1.84c0,0.79-0.18,1.41-0.53,1.84C323.06,105.59,322.57,105.8,321.94,105.8z
			 M321.84,101.43c-0.49,0-0.85,0.14-1.07,0.41s-0.33,0.71-0.34,1.3v0.16c0,0.68,0.11,1.16,0.34,1.45s0.59,0.44,1.09,0.44
			c0.42,0,0.74-0.17,0.98-0.51c0.24-0.34,0.35-0.8,0.35-1.39c0-0.6-0.12-1.06-0.35-1.38C322.6,101.59,322.26,101.43,321.84,101.43z"
          />
          <path       className={clsx(inView && classes.animation, classes.st1)} d="M325.95,105.72h-0.73v-6.84h0.73V105.72z" />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M329.53,105.8c-0.71,0-1.27-0.22-1.69-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6s0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.15,0.44c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24
			C330.13,105.78,329.85,105.8,329.53,105.8z M329.33,101.42c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C330,101.55,329.71,101.42,329.33,101.42z"
          />
        </g>
        <path
                className={clsx(inView && classes.animation, classes.st1)}
          d="M268.65,117.71l-0.15-0.69h-0.04c-0.24,0.3-0.48,0.51-0.72,0.61c-0.24,0.11-0.54,0.16-0.89,0.16
		c-0.48,0-0.85-0.12-1.12-0.37c-0.27-0.25-0.41-0.6-0.41-1.05c0-0.97,0.78-1.48,2.33-1.53l0.82-0.03v-0.3
		c0-0.38-0.08-0.66-0.24-0.84s-0.42-0.27-0.78-0.27c-0.4,0-0.86,0.12-1.36,0.37l-0.22-0.56c0.24-0.13,0.5-0.23,0.78-0.3
		c0.28-0.07,0.57-0.11,0.85-0.11c0.57,0,1,0.13,1.28,0.38s0.42,0.66,0.42,1.23v3.29H268.65z M267,117.2c0.45,0,0.81-0.12,1.07-0.37
		c0.26-0.25,0.39-0.6,0.39-1.05v-0.44l-0.73,0.03c-0.58,0.02-1,0.11-1.25,0.27c-0.26,0.16-0.38,0.41-0.38,0.74
		c0,0.26,0.08,0.46,0.24,0.6C266.49,117.13,266.71,117.2,267,117.2z M272.86,113.46h-1.23v4.25h-0.73v-4.25h-0.86v-0.33l0.86-0.26
		v-0.27c0-1.18,0.52-1.78,1.55-1.78c0.25,0,0.55,0.05,0.9,0.15l-0.19,0.58c-0.28-0.09-0.52-0.14-0.72-0.14
		c-0.28,0-0.48,0.09-0.61,0.27c-0.13,0.18-0.2,0.48-0.2,0.88v0.31h1.23V113.46z M275.91,113.46h-1.23v4.25h-0.73v-4.25h-0.86v-0.33
		l0.86-0.26v-0.27c0-1.18,0.52-1.78,1.55-1.78c0.25,0,0.55,0.05,0.9,0.15l-0.19,0.58c-0.28-0.09-0.52-0.14-0.72-0.14
		c-0.28,0-0.48,0.09-0.61,0.27c-0.13,0.18-0.2,0.48-0.2,0.88v0.31h1.23V113.46z M278.83,117.8c-0.71,0-1.27-0.22-1.69-0.65
		c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85s0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6
		c0.35,0.4,0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29c0.27,0.29,0.65,0.44,1.14,0.44
		c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24C279.43,117.78,279.15,117.8,278.83,117.8z M278.63,113.42
		c-0.39,0-0.7,0.13-0.93,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52c0-0.46-0.1-0.81-0.31-1.06
		C279.3,113.54,279.01,113.42,278.63,113.42z M284.98,117.55c-0.32,0.17-0.73,0.25-1.22,0.25c-0.7,0-1.24-0.21-1.62-0.64
		c-0.38-0.43-0.57-1.04-0.57-1.82c0-0.81,0.19-1.43,0.58-1.87c0.39-0.44,0.94-0.66,1.66-0.66c0.23,0,0.46,0.02,0.69,0.07
		c0.23,0.05,0.41,0.11,0.54,0.18l-0.22,0.62c-0.16-0.06-0.34-0.12-0.53-0.16c-0.19-0.04-0.36-0.06-0.51-0.06
		c-0.98,0-1.47,0.62-1.47,1.87c0,0.59,0.12,1.05,0.36,1.36c0.24,0.32,0.59,0.47,1.06,0.47c0.4,0,0.81-0.09,1.23-0.26V117.55
		L284.98,117.55z M287.68,117.2c0.13,0,0.25-0.01,0.37-0.03c0.12-0.02,0.22-0.04,0.29-0.06v0.56c-0.08,0.04-0.2,0.07-0.35,0.09
		c-0.15,0.02-0.29,0.04-0.42,0.04c-0.93,0-1.4-0.49-1.4-1.47v-2.87h-0.69v-0.35l0.69-0.3l0.31-1.03h0.42v1.12h1.4v0.57h-1.4v2.83
		c0,0.29,0.07,0.51,0.21,0.67C287.25,117.12,287.44,117.2,287.68,117.2z M291.34,117.8c-0.71,0-1.27-0.22-1.69-0.65
		c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85s0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6
		c0.35,0.4,0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29c0.27,0.29,0.65,0.44,1.14,0.44
		c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24C291.94,117.78,291.66,117.8,291.34,117.8z M291.14,113.42
		c-0.39,0-0.7,0.13-0.93,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52c0-0.46-0.1-0.81-0.31-1.06
		C291.81,113.54,291.52,113.42,291.14,113.42z M297.63,117.07h-0.04c-0.34,0.49-0.84,0.73-1.51,0.73c-0.63,0-1.12-0.22-1.47-0.65
		c-0.35-0.43-0.53-1.04-0.53-1.84c0-0.79,0.18-1.41,0.53-1.85s0.84-0.66,1.47-0.66c0.65,0,1.15,0.24,1.5,0.71h0.06l-0.03-0.35
		l-0.02-0.34v-1.96h0.73v6.84h-0.59L297.63,117.07z M296.17,117.19c0.5,0,0.86-0.14,1.08-0.41c0.22-0.27,0.34-0.71,0.34-1.31v-0.15
		c0-0.68-0.11-1.17-0.34-1.46c-0.23-0.29-0.59-0.44-1.09-0.44c-0.43,0-0.76,0.17-0.98,0.5c-0.23,0.33-0.34,0.8-0.34,1.41
		c0,0.62,0.11,1.08,0.34,1.39C295.4,117.03,295.74,117.19,296.17,117.19z M302.77,113.54c0.34-0.48,0.84-0.72,1.51-0.72
		c0.63,0,1.12,0.22,1.47,0.65c0.35,0.43,0.53,1.04,0.53,1.83s-0.18,1.41-0.53,1.84c-0.35,0.44-0.84,0.66-1.47,0.66
		c-0.31,0-0.6-0.06-0.86-0.17s-0.48-0.29-0.65-0.53h-0.05l-0.15,0.62h-0.52v-6.84h0.73v1.66c0,0.37-0.01,0.71-0.04,1H302.77
		L302.77,113.54z M304.18,113.43c-0.5,0-0.86,0.14-1.08,0.43s-0.33,0.77-0.33,1.44s0.11,1.16,0.34,1.45
		c0.23,0.29,0.59,0.44,1.09,0.44c0.45,0,0.78-0.16,1-0.49c0.22-0.33,0.33-0.8,0.33-1.41c0-0.63-0.11-1.09-0.33-1.4
		S304.64,113.43,304.18,113.43z M306.79,112.9h0.78l1.05,2.75c0.23,0.63,0.37,1.08,0.43,1.36h0.04c0.04-0.15,0.12-0.4,0.24-0.77
		c0.12-0.36,0.52-1.47,1.19-3.34h0.78l-2.07,5.48c-0.21,0.54-0.44,0.93-0.72,1.15c-0.27,0.23-0.61,0.34-1.01,0.34
		c-0.22,0-0.44-0.02-0.66-0.07v-0.58c0.16,0.04,0.34,0.05,0.54,0.05c0.5,0,0.86-0.28,1.07-0.84l0.27-0.69L306.79,112.9z
		 M317.4,117.55c-0.32,0.17-0.73,0.25-1.22,0.25c-0.7,0-1.24-0.21-1.62-0.64c-0.38-0.43-0.57-1.04-0.57-1.82
		c0-0.81,0.19-1.43,0.58-1.87c0.39-0.44,0.94-0.66,1.66-0.66c0.23,0,0.46,0.02,0.69,0.07c0.23,0.05,0.41,0.11,0.54,0.18l-0.22,0.62
		c-0.16-0.06-0.34-0.12-0.53-0.16c-0.19-0.04-0.36-0.06-0.51-0.06c-0.98,0-1.47,0.62-1.47,1.87c0,0.59,0.12,1.05,0.36,1.36
		c0.24,0.32,0.59,0.47,1.06,0.47c0.4,0,0.81-0.09,1.23-0.26V117.55L317.4,117.55z M322.7,115.3c0,0.79-0.2,1.4-0.59,1.84
		c-0.4,0.44-0.94,0.66-1.64,0.66c-0.43,0-0.81-0.1-1.15-0.3s-0.59-0.49-0.77-0.87c-0.18-0.38-0.27-0.82-0.27-1.33
		c0-0.79,0.2-1.4,0.59-1.83c0.39-0.44,0.94-0.66,1.63-0.66c0.67,0,1.21,0.22,1.61,0.67C322.5,113.93,322.7,114.54,322.7,115.3z
		 M319.03,115.3c0,0.62,0.12,1.08,0.37,1.41c0.25,0.32,0.61,0.48,1.09,0.48c0.48,0,0.84-0.16,1.09-0.48
		c0.25-0.32,0.37-0.79,0.37-1.41c0-0.61-0.12-1.08-0.37-1.4c-0.25-0.32-0.61-0.48-1.1-0.48c-0.48,0-0.84,0.16-1.08,0.47
		C319.15,114.21,319.03,114.68,319.03,115.3z M327.27,117.71v-3.12c0-0.39-0.09-0.69-0.27-0.88c-0.18-0.19-0.46-0.29-0.84-0.29
		c-0.5,0-0.87,0.14-1.11,0.41c-0.23,0.27-0.35,0.72-0.35,1.35v2.53h-0.73v-4.82h0.59l0.12,0.66h0.04c0.15-0.24,0.36-0.42,0.63-0.55
		c0.27-0.13,0.57-0.2,0.9-0.2c0.58,0,1.02,0.14,1.31,0.42c0.29,0.28,0.44,0.73,0.44,1.34v3.14H327.27z M331.67,113.46h-1.23v4.25
		h-0.73v-4.25h-0.86v-0.33l0.86-0.26v-0.27c0-1.18,0.52-1.78,1.55-1.78c0.25,0,0.55,0.05,0.9,0.15l-0.19,0.58
		c-0.28-0.09-0.52-0.14-0.72-0.14c-0.28,0-0.48,0.09-0.61,0.27c-0.13,0.18-0.2,0.48-0.2,0.88v0.31h1.23V113.46z M333.28,117.71
		h-0.73v-6.84h0.73V117.71z M334.77,111.59c0-0.17,0.04-0.29,0.12-0.37c0.08-0.08,0.18-0.12,0.31-0.12c0.12,0,0.22,0.04,0.3,0.12
		c0.08,0.08,0.13,0.2,0.13,0.36c0,0.16-0.04,0.29-0.13,0.37c-0.09,0.08-0.19,0.12-0.3,0.12c-0.12,0-0.23-0.04-0.31-0.12
		C334.81,111.88,334.77,111.76,334.77,111.59z M335.56,117.71h-0.73v-4.82h0.73V117.71z M340.25,117.55
		c-0.32,0.17-0.73,0.25-1.22,0.25c-0.7,0-1.24-0.21-1.62-0.64c-0.38-0.43-0.57-1.04-0.57-1.82c0-0.81,0.19-1.43,0.58-1.87
		c0.39-0.44,0.94-0.66,1.66-0.66c0.23,0,0.46,0.02,0.69,0.07c0.23,0.05,0.41,0.11,0.54,0.18l-0.22,0.62
		c-0.16-0.06-0.34-0.12-0.53-0.16c-0.19-0.04-0.36-0.06-0.51-0.06c-0.98,0-1.47,0.62-1.47,1.87c0,0.59,0.12,1.05,0.36,1.36
		c0.24,0.32,0.59,0.47,1.06,0.47c0.4,0,0.81-0.09,1.23-0.26V117.55L340.25,117.55z M342.95,117.2c0.13,0,0.25-0.01,0.37-0.03
		c0.12-0.02,0.22-0.04,0.29-0.06v0.56c-0.08,0.04-0.2,0.07-0.35,0.09c-0.15,0.02-0.29,0.04-0.42,0.04c-0.93,0-1.4-0.49-1.4-1.47
		v-2.87h-0.69v-0.35l0.69-0.3l0.31-1.03h0.42v1.12h1.4v0.57h-1.4v2.83c0,0.29,0.07,0.51,0.21,0.67
		C342.52,117.12,342.71,117.2,342.95,117.2z"
        />
        <g>
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M268.65,129.71l-0.14-0.69h-0.04c-0.24,0.3-0.48,0.51-0.72,0.61c-0.24,0.11-0.54,0.16-0.89,0.16
			c-0.48,0-0.85-0.12-1.12-0.37c-0.27-0.25-0.41-0.6-0.41-1.05c0-0.97,0.78-1.48,2.33-1.53l0.82-0.03v-0.3
			c0-0.38-0.08-0.66-0.24-0.84c-0.16-0.18-0.42-0.27-0.78-0.27c-0.4,0-0.86,0.12-1.36,0.37l-0.22-0.56c0.24-0.13,0.5-0.23,0.78-0.3
			c0.28-0.07,0.57-0.11,0.85-0.11c0.57,0,1,0.13,1.28,0.38c0.28,0.25,0.42,0.66,0.42,1.23v3.29H268.65z M267,129.2
			c0.45,0,0.81-0.12,1.07-0.37c0.26-0.25,0.39-0.6,0.39-1.05v-0.44l-0.73,0.03c-0.58,0.02-1,0.11-1.25,0.27
			c-0.26,0.16-0.38,0.41-0.38,0.74c0,0.26,0.08,0.46,0.24,0.6C266.49,129.13,266.71,129.2,267,129.2z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M273.99,129.71v-3.12c0-0.39-0.09-0.69-0.27-0.88s-0.46-0.29-0.84-0.29c-0.5,0-0.87,0.14-1.11,0.41
			s-0.35,0.72-0.35,1.35v2.53h-0.73v-4.82h0.59l0.12,0.66h0.04c0.15-0.24,0.36-0.42,0.63-0.55c0.27-0.13,0.57-0.2,0.9-0.2
			c0.58,0,1.02,0.14,1.31,0.42s0.44,0.73,0.44,1.34v3.14H273.99z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M279.49,129.06h-0.04c-0.34,0.49-0.84,0.73-1.51,0.73c-0.63,0-1.12-0.22-1.47-0.65
			c-0.35-0.43-0.52-1.04-0.52-1.84s0.18-1.41,0.53-1.85s0.84-0.66,1.47-0.66c0.65,0,1.15,0.24,1.5,0.71h0.06l-0.03-0.35l-0.02-0.34
			v-1.96h0.73v6.84h-0.59L279.49,129.06z M278.04,129.19c0.5,0,0.86-0.14,1.08-0.41c0.22-0.27,0.34-0.71,0.34-1.31v-0.15
			c0-0.68-0.11-1.17-0.34-1.46c-0.23-0.29-0.59-0.44-1.09-0.44c-0.43,0-0.75,0.17-0.98,0.5c-0.23,0.33-0.34,0.8-0.34,1.41
			c0,0.62,0.11,1.08,0.34,1.39S277.6,129.19,278.04,129.19z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M284.01,123.59c0-0.17,0.04-0.29,0.12-0.37s0.18-0.12,0.31-0.12c0.12,0,0.22,0.04,0.3,0.12
			s0.13,0.2,0.13,0.36s-0.04,0.29-0.13,0.37c-0.08,0.08-0.19,0.12-0.3,0.12c-0.12,0-0.23-0.04-0.31-0.12
			C284.05,123.88,284.01,123.75,284.01,123.59z M284.8,129.71h-0.73v-4.82h0.73V129.71z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M289.64,129.71v-3.12c0-0.39-0.09-0.69-0.27-0.88s-0.46-0.29-0.84-0.29c-0.5,0-0.87,0.14-1.11,0.41
			s-0.35,0.72-0.35,1.35v2.53h-0.73v-4.82h0.59l0.12,0.66h0.04c0.15-0.24,0.36-0.42,0.63-0.55c0.27-0.13,0.57-0.2,0.9-0.2
			c0.58,0,1.02,0.14,1.31,0.42s0.44,0.73,0.44,1.34v3.14H289.64z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M294.98,128.4c0,0.45-0.17,0.79-0.5,1.04s-0.8,0.36-1.41,0.36c-0.64,0-1.14-0.1-1.49-0.3v-0.68
			c0.23,0.12,0.48,0.21,0.74,0.28c0.27,0.07,0.52,0.1,0.77,0.1c0.38,0,0.67-0.06,0.88-0.18s0.31-0.31,0.31-0.56
			c0-0.19-0.08-0.35-0.24-0.48c-0.16-0.13-0.48-0.29-0.95-0.47c-0.45-0.17-0.77-0.31-0.96-0.44c-0.19-0.12-0.33-0.27-0.42-0.42
			c-0.09-0.16-0.14-0.35-0.14-0.57c0-0.39,0.16-0.7,0.48-0.93s0.76-0.34,1.31-0.34c0.52,0,1.03,0.11,1.52,0.32l-0.26,0.59
			c-0.48-0.2-0.92-0.3-1.31-0.3c-0.35,0-0.61,0.05-0.78,0.16s-0.26,0.26-0.26,0.45c0,0.13,0.03,0.24,0.1,0.33
			c0.07,0.09,0.17,0.18,0.32,0.26s0.43,0.2,0.84,0.36c0.57,0.21,0.96,0.42,1.16,0.63C294.88,127.81,294.98,128.08,294.98,128.4z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M298.2,129.8c-0.71,0-1.27-0.22-1.68-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6s0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.14,0.44c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24
			C298.8,129.77,298.52,129.8,298.2,129.8z M298,125.42c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C298.67,125.54,298.38,125.42,298,125.42z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M303.14,129.8c-0.7,0-1.24-0.21-1.62-0.64c-0.38-0.43-0.57-1.04-0.57-1.82c0-0.81,0.19-1.43,0.58-1.87
			c0.39-0.44,0.94-0.66,1.66-0.66c0.23,0,0.46,0.02,0.69,0.07s0.41,0.11,0.54,0.18l-0.22,0.62c-0.16-0.06-0.34-0.12-0.53-0.16
			s-0.36-0.06-0.5-0.06c-0.98,0-1.47,0.62-1.47,1.87c0,0.59,0.12,1.05,0.36,1.36c0.24,0.32,0.59,0.47,1.06,0.47
			c0.4,0,0.81-0.09,1.24-0.26v0.65C304.03,129.72,303.63,129.8,303.14,129.8z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M306.18,124.89v3.12c0,0.39,0.09,0.69,0.27,0.88s0.46,0.29,0.84,0.29c0.5,0,0.87-0.14,1.11-0.41
			c0.23-0.28,0.35-0.73,0.35-1.35v-2.53h0.73v4.82h-0.6l-0.11-0.65h-0.04c-0.15,0.24-0.36,0.42-0.62,0.54
			c-0.27,0.13-0.57,0.19-0.91,0.19c-0.59,0-1.02-0.14-1.32-0.42c-0.29-0.28-0.44-0.72-0.44-1.34v-3.15H306.18z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M313.22,124.81c0.21,0,0.41,0.02,0.58,0.05l-0.1,0.68c-0.2-0.04-0.38-0.07-0.53-0.07
			c-0.39,0-0.72,0.16-1,0.47c-0.28,0.32-0.42,0.71-0.42,1.18v2.58h-0.73v-4.82h0.6l0.08,0.89h0.04c0.18-0.31,0.39-0.56,0.65-0.73
			S312.92,124.81,313.22,124.81z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M314.63,123.59c0-0.17,0.04-0.29,0.12-0.37s0.18-0.12,0.31-0.12c0.12,0,0.22,0.04,0.3,0.12
			s0.13,0.2,0.13,0.36s-0.04,0.29-0.13,0.37c-0.08,0.08-0.19,0.12-0.3,0.12c-0.12,0-0.23-0.04-0.31-0.12
			C314.67,123.88,314.63,123.75,314.63,123.59z M315.42,129.71h-0.73v-4.82h0.73V129.71z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M318.53,129.2c0.13,0,0.25-0.01,0.37-0.03c0.12-0.02,0.21-0.04,0.29-0.06v0.56c-0.08,0.04-0.2,0.07-0.35,0.09
			c-0.15,0.02-0.29,0.04-0.42,0.04c-0.93,0-1.4-0.49-1.4-1.47v-2.87h-0.69v-0.35l0.69-0.3l0.31-1.03h0.42v1.12h1.4v0.57h-1.4v2.83
			c0,0.29,0.07,0.51,0.21,0.67S318.29,129.2,318.53,129.2z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M319.38,124.89h0.78l1.05,2.75c0.23,0.63,0.38,1.08,0.43,1.36h0.04c0.04-0.15,0.12-0.4,0.24-0.77
			c0.12-0.36,0.52-1.47,1.19-3.34h0.78l-2.07,5.48c-0.21,0.54-0.44,0.93-0.72,1.15c-0.27,0.23-0.61,0.34-1.01,0.34
			c-0.22,0-0.44-0.02-0.66-0.07v-0.58c0.16,0.04,0.34,0.05,0.54,0.05c0.5,0,0.86-0.28,1.07-0.84l0.27-0.69L319.38,124.89z"
          />
        </g>
        <g>
          <path
            className={clsx(inView && classes.animation, classes.st0)}
            d="M70.3,107.28c0,0.77-0.22,1.4-0.67,1.91c-0.45,0.51-1.08,0.85-1.89,1.03v0.07c0.97,0.12,1.7,0.42,2.18,0.91
			s0.73,1.12,0.73,1.92c0,1.16-0.41,2.06-1.23,2.69c-0.82,0.63-1.99,0.95-3.51,0.95c-1.34,0-2.47-0.22-3.39-0.65v-1.73
			c0.51,0.25,1.06,0.45,1.63,0.59s1.12,0.21,1.65,0.21c0.94,0,1.64-0.17,2.1-0.52c0.46-0.35,0.69-0.88,0.69-1.61
			c0-0.65-0.26-1.12-0.77-1.42c-0.51-0.3-1.32-0.46-2.42-0.46h-1.05v-1.58h1.07c1.93,0,2.9-0.67,2.9-2c0-0.52-0.17-0.92-0.5-1.2
			c-0.34-0.28-0.83-0.42-1.49-0.42c-0.46,0-0.9,0.06-1.32,0.19c-0.42,0.13-0.93,0.38-1.5,0.76l-0.95-1.36
			c1.11-0.82,2.4-1.22,3.86-1.22c1.22,0,2.17,0.26,2.85,0.79S70.3,106.36,70.3,107.28z"
          />
          <path
            className={clsx(inView && classes.animation, classes.st0)}
            d="M80.86,113.95h-1.63v2.64h-1.89v-2.64h-5.53v-1.5l5.53-7.99h1.89v7.87h1.63V113.95z M77.33,112.34v-3.04
			c0-1.08,0.03-1.97,0.08-2.66h-0.07c-0.15,0.36-0.4,0.81-0.73,1.32l-3,4.37H77.33z"
          />
        </g>
        <g>
          <path
            className={clsx(inView && classes.animation, classes.st0)}
            d="M89.68,116.59l-3.51-10.1h-0.07c0.09,1.5,0.14,2.91,0.14,4.22v5.88h-1.79V104.5h2.79l3.36,9.62h0.05
			l3.46-9.62h2.8v12.09H95v-5.98c0-0.6,0.01-1.38,0.04-2.35c0.03-0.96,0.06-1.55,0.08-1.75h-0.07l-3.63,10.08H89.68z"
          />
        </g>
        <g>
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M47.7,132.2l-0.15-0.69h-0.04c-0.24,0.3-0.48,0.51-0.72,0.61c-0.24,0.11-0.54,0.16-0.89,0.16
			c-0.48,0-0.85-0.12-1.12-0.37c-0.27-0.25-0.41-0.6-0.41-1.05c0-0.97,0.78-1.48,2.33-1.53l0.82-0.03v-0.3
			c0-0.38-0.08-0.66-0.24-0.84c-0.16-0.18-0.42-0.27-0.78-0.27c-0.4,0-0.86,0.12-1.36,0.37l-0.22-0.56c0.24-0.13,0.5-0.23,0.78-0.3
			c0.28-0.07,0.57-0.11,0.85-0.11c0.57,0,1,0.13,1.28,0.38c0.28,0.25,0.42,0.66,0.42,1.23v3.29H47.7z M46.05,131.68
			c0.45,0,0.81-0.12,1.07-0.37c0.26-0.25,0.39-0.6,0.39-1.05v-0.44l-0.73,0.03c-0.58,0.02-1,0.11-1.25,0.27
			c-0.26,0.16-0.38,0.41-0.38,0.74c0,0.26,0.08,0.46,0.24,0.6C45.54,131.62,45.76,131.68,46.05,131.68z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M51.66,132.29c-0.7,0-1.24-0.21-1.62-0.64c-0.38-0.43-0.57-1.04-0.57-1.82c0-0.81,0.19-1.43,0.58-1.87
			c0.39-0.44,0.94-0.66,1.66-0.66c0.23,0,0.46,0.02,0.69,0.07s0.41,0.11,0.54,0.18l-0.22,0.62c-0.16-0.06-0.34-0.12-0.53-0.16
			s-0.36-0.06-0.5-0.06c-0.98,0-1.47,0.62-1.47,1.87c0,0.59,0.12,1.05,0.36,1.36c0.24,0.32,0.59,0.47,1.06,0.47
			c0.4,0,0.81-0.09,1.24-0.26v0.65C52.56,132.2,52.15,132.29,51.66,132.29z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M54.71,127.38v3.12c0,0.39,0.09,0.69,0.27,0.88s0.46,0.29,0.84,0.29c0.5,0,0.87-0.14,1.11-0.41
			c0.23-0.27,0.35-0.72,0.35-1.35v-2.53H58v4.82h-0.6l-0.11-0.65h-0.04c-0.15,0.24-0.36,0.42-0.62,0.54
			c-0.27,0.13-0.57,0.19-0.91,0.19c-0.59,0-1.02-0.14-1.32-0.42c-0.29-0.28-0.44-0.72-0.44-1.34v-3.15H54.71z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M61.1,131.68c0.13,0,0.25-0.01,0.37-0.03c0.12-0.02,0.21-0.04,0.29-0.06v0.56c-0.08,0.04-0.2,0.07-0.35,0.09
			c-0.15,0.02-0.29,0.04-0.42,0.04c-0.93,0-1.4-0.49-1.4-1.47v-2.87h-0.69v-0.35l0.69-0.3l0.31-1.03h0.42v1.12h1.4v0.57h-1.4v2.83
			c0,0.29,0.07,0.51,0.21,0.67S60.86,131.68,61.1,131.68z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M64.76,132.29c-0.71,0-1.27-0.22-1.68-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6s0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.14,0.44c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24
			C65.36,132.26,65.09,132.29,64.76,132.29z M64.56,127.91c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C65.24,128.03,64.94,127.91,64.56,127.91z"
          />
          <path       className={clsx(inView && classes.animation, classes.st1)} d="M68.5,132.2h-0.73v-6.84h0.73V132.2z" />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M69.29,127.38h0.78l1.05,2.75c0.23,0.63,0.38,1.08,0.43,1.36h0.04c0.04-0.15,0.12-0.41,0.24-0.77
			c0.12-0.36,0.52-1.47,1.19-3.34h0.78l-2.07,5.48c-0.21,0.54-0.45,0.93-0.72,1.15c-0.27,0.23-0.61,0.34-1.01,0.34
			c-0.22,0-0.44-0.03-0.66-0.08v-0.58c0.16,0.04,0.34,0.05,0.54,0.05c0.5,0,0.86-0.28,1.07-0.84l0.27-0.69L69.29,127.38z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M79.1,127.95h-1.23v4.25h-0.73v-4.25h-0.86v-0.33l0.86-0.26v-0.27c0-1.18,0.52-1.78,1.55-1.78
			c0.25,0,0.55,0.05,0.9,0.15l-0.19,0.58c-0.28-0.09-0.52-0.14-0.72-0.14c-0.28,0-0.48,0.09-0.61,0.27c-0.13,0.18-0.2,0.48-0.2,0.88
			v0.31h1.23V127.95z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M84.13,129.79c0,0.79-0.2,1.4-0.59,1.84c-0.4,0.44-0.94,0.66-1.64,0.66c-0.43,0-0.81-0.1-1.15-0.3
			s-0.59-0.49-0.77-0.87c-0.18-0.38-0.27-0.82-0.27-1.33c0-0.79,0.2-1.4,0.59-1.83s0.94-0.66,1.63-0.66c0.67,0,1.21,0.22,1.61,0.67
			C83.93,128.42,84.13,129.02,84.13,129.79z M80.46,129.79c0,0.62,0.12,1.08,0.37,1.41c0.25,0.32,0.61,0.48,1.08,0.48
			s0.84-0.16,1.09-0.48c0.25-0.32,0.37-0.79,0.37-1.41c0-0.61-0.12-1.08-0.37-1.4c-0.25-0.32-0.61-0.48-1.1-0.48
			c-0.48,0-0.84,0.16-1.08,0.47S80.46,129.17,80.46,129.79z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M89.57,129.79c0,0.79-0.2,1.4-0.59,1.84c-0.4,0.44-0.94,0.66-1.64,0.66c-0.43,0-0.81-0.1-1.15-0.3
			s-0.59-0.49-0.77-0.87c-0.18-0.38-0.27-0.82-0.27-1.33c0-0.79,0.2-1.4,0.59-1.83s0.94-0.66,1.63-0.66c0.67,0,1.21,0.22,1.61,0.67
			C89.37,128.42,89.57,129.02,89.57,129.79z M85.9,129.79c0,0.62,0.12,1.08,0.37,1.41c0.25,0.32,0.61,0.48,1.09,0.48
			s0.84-0.16,1.09-0.48c0.25-0.32,0.37-0.79,0.37-1.41c0-0.61-0.12-1.08-0.37-1.4c-0.25-0.32-0.61-0.48-1.1-0.48
			c-0.48,0-0.84,0.16-1.08,0.47S85.9,129.17,85.9,129.79z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M94.12,131.55h-0.04c-0.34,0.49-0.84,0.73-1.51,0.73c-0.63,0-1.12-0.22-1.47-0.65
			c-0.35-0.43-0.52-1.04-0.52-1.84s0.18-1.41,0.53-1.85s0.84-0.66,1.47-0.66c0.65,0,1.15,0.24,1.5,0.71h0.06l-0.03-0.35l-0.02-0.34
			v-1.96h0.73v6.84h-0.59L94.12,131.55z M92.67,131.68c0.5,0,0.86-0.13,1.08-0.41c0.22-0.27,0.34-0.71,0.34-1.31v-0.15
			c0-0.68-0.11-1.17-0.34-1.46c-0.23-0.29-0.59-0.44-1.09-0.44c-0.43,0-0.75,0.17-0.98,0.5c-0.23,0.33-0.34,0.8-0.34,1.41
			c0,0.62,0.11,1.08,0.34,1.39S92.23,131.68,92.67,131.68z"
          />
          <path       className={clsx(inView && classes.animation, classes.st1)} d="M95.96,130.12v-0.67h2.16v0.67H95.96z" />
        </g>
        <g>
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M32.34,138.07c0-0.17,0.04-0.29,0.12-0.37c0.08-0.08,0.18-0.12,0.31-0.12c0.12,0,0.22,0.04,0.3,0.12
			s0.13,0.2,0.13,0.36s-0.04,0.29-0.13,0.37c-0.08,0.08-0.19,0.12-0.3,0.12c-0.12,0-0.23-0.04-0.31-0.12
			C32.38,138.36,32.34,138.24,32.34,138.07z M33.13,144.2h-0.73v-4.82h0.73V144.2z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M37.98,144.2v-3.12c0-0.39-0.09-0.69-0.27-0.88s-0.46-0.29-0.84-0.29c-0.5,0-0.87,0.14-1.11,0.41
			s-0.35,0.72-0.35,1.35v2.53h-0.73v-4.82h0.59l0.12,0.66h0.04c0.15-0.24,0.36-0.42,0.63-0.55c0.27-0.13,0.57-0.2,0.9-0.2
			c0.58,0,1.02,0.14,1.31,0.42c0.29,0.28,0.44,0.73,0.44,1.34v3.14H37.98z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M43.31,142.88c0,0.45-0.17,0.79-0.5,1.04s-0.8,0.37-1.41,0.37c-0.64,0-1.14-0.1-1.49-0.3v-0.68
			c0.23,0.12,0.48,0.21,0.75,0.28c0.26,0.07,0.52,0.1,0.77,0.1c0.38,0,0.67-0.06,0.88-0.18c0.21-0.12,0.31-0.31,0.31-0.56
			c0-0.19-0.08-0.35-0.24-0.48c-0.16-0.13-0.48-0.29-0.95-0.47c-0.45-0.17-0.77-0.31-0.96-0.44c-0.19-0.12-0.33-0.27-0.42-0.42
			c-0.09-0.16-0.14-0.35-0.14-0.57c0-0.39,0.16-0.7,0.48-0.93c0.32-0.23,0.76-0.34,1.31-0.34c0.52,0,1.03,0.11,1.52,0.32l-0.26,0.59
			c-0.48-0.2-0.92-0.3-1.31-0.3c-0.35,0-0.61,0.05-0.78,0.16s-0.26,0.26-0.26,0.45c0,0.13,0.03,0.24,0.1,0.33
			c0.07,0.09,0.17,0.18,0.32,0.26s0.43,0.2,0.84,0.36c0.57,0.21,0.96,0.42,1.16,0.63C43.21,142.3,43.31,142.56,43.31,142.88z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M46.53,144.28c-0.71,0-1.27-0.22-1.69-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6c0.35,0.4,0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.15,0.44c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24
			C47.14,144.26,46.86,144.28,46.53,144.28z M46.34,139.9c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C47.01,140.03,46.72,139.9,46.34,139.9z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M51.47,144.28c-0.7,0-1.24-0.21-1.62-0.64c-0.38-0.43-0.57-1.04-0.57-1.82c0-0.81,0.19-1.43,0.58-1.87
			c0.39-0.44,0.94-0.66,1.66-0.66c0.23,0,0.46,0.02,0.69,0.07s0.41,0.11,0.54,0.18l-0.22,0.62c-0.16-0.06-0.34-0.12-0.53-0.16
			c-0.19-0.04-0.36-0.06-0.51-0.06c-0.98,0-1.47,0.62-1.47,1.87c0,0.59,0.12,1.05,0.36,1.36c0.24,0.32,0.59,0.47,1.06,0.47
			c0.4,0,0.81-0.09,1.23-0.26v0.65C52.37,144.2,51.96,144.28,51.47,144.28z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M54.52,139.38v3.12c0,0.39,0.09,0.69,0.27,0.88s0.46,0.29,0.84,0.29c0.5,0,0.87-0.14,1.11-0.41
			c0.23-0.28,0.35-0.72,0.35-1.35v-2.53h0.73v4.82h-0.6l-0.11-0.65h-0.04c-0.15,0.24-0.36,0.42-0.62,0.54
			c-0.27,0.13-0.57,0.19-0.91,0.19c-0.59,0-1.03-0.14-1.32-0.42c-0.29-0.28-0.44-0.72-0.44-1.34v-3.15H54.52z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M61.55,139.29c0.21,0,0.41,0.02,0.58,0.05l-0.1,0.68c-0.2-0.04-0.38-0.07-0.53-0.07c-0.39,0-0.72,0.16-1,0.47
			c-0.28,0.32-0.42,0.71-0.42,1.18v2.58h-0.73v-4.82h0.6l0.08,0.89h0.04c0.18-0.31,0.39-0.55,0.65-0.72S61.25,139.29,61.55,139.29z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M65.07,144.28c-0.71,0-1.27-0.22-1.68-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6c0.35,0.4,0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.14,0.44c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24
			C65.67,144.26,65.39,144.28,65.07,144.28z M64.87,139.9c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C65.54,140.03,65.25,139.9,64.87,139.9z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M72.66,144.28c-0.31,0-0.6-0.06-0.86-0.17c-0.26-0.12-0.48-0.29-0.65-0.53h-0.05
			c0.04,0.28,0.05,0.55,0.05,0.8v1.98h-0.73v-6.98h0.59l0.1,0.66h0.04c0.19-0.26,0.41-0.45,0.66-0.57s0.53-0.18,0.86-0.18
			c0.64,0,1.13,0.22,1.48,0.65c0.35,0.44,0.52,1.05,0.52,1.84c0,0.79-0.18,1.41-0.53,1.84C73.78,144.07,73.29,144.28,72.66,144.28z
			 M72.55,139.91c-0.49,0-0.85,0.14-1.07,0.41s-0.33,0.71-0.34,1.3v0.16c0,0.68,0.11,1.16,0.34,1.45c0.23,0.29,0.59,0.44,1.08,0.44
			c0.42,0,0.74-0.17,0.98-0.5c0.24-0.34,0.35-0.8,0.35-1.39c0-0.6-0.12-1.06-0.35-1.38C73.31,140.07,72.98,139.91,72.55,139.91z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M77.97,144.28c-0.71,0-1.27-0.22-1.68-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6c0.35,0.4,0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.14,0.44c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24
			C78.57,144.26,78.29,144.28,77.97,144.28z M77.77,139.9c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C78.44,140.03,78.15,139.9,77.77,139.9z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M85.14,141.78c0,0.79-0.2,1.4-0.59,1.84c-0.4,0.44-0.94,0.66-1.64,0.66c-0.43,0-0.81-0.1-1.15-0.3
			s-0.59-0.49-0.77-0.87s-0.27-0.82-0.27-1.33c0-0.79,0.2-1.4,0.59-1.83c0.39-0.44,0.94-0.66,1.63-0.66c0.67,0,1.21,0.22,1.61,0.67
			C84.94,140.41,85.14,141.02,85.14,141.78z M81.47,141.78c0,0.62,0.12,1.08,0.37,1.41s0.61,0.48,1.08,0.48s0.84-0.16,1.09-0.48
			c0.25-0.32,0.37-0.79,0.37-1.41c0-0.61-0.12-1.08-0.37-1.39c-0.25-0.32-0.61-0.48-1.1-0.48c-0.48,0-0.84,0.16-1.08,0.47
			S81.47,141.16,81.47,141.78z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M88.66,144.28c-0.31,0-0.6-0.06-0.86-0.17c-0.26-0.12-0.48-0.29-0.65-0.53H87.1c0.04,0.28,0.05,0.55,0.05,0.8
			v1.98h-0.73v-6.98h0.59l0.1,0.66h0.04c0.19-0.26,0.41-0.45,0.65-0.57s0.54-0.18,0.86-0.18c0.64,0,1.13,0.22,1.48,0.65
			c0.35,0.44,0.52,1.05,0.52,1.84c0,0.79-0.18,1.41-0.53,1.84C89.78,144.07,89.29,144.28,88.66,144.28z M88.55,139.91
			c-0.49,0-0.85,0.14-1.07,0.41s-0.33,0.71-0.34,1.3v0.16c0,0.68,0.11,1.16,0.34,1.45c0.23,0.29,0.59,0.44,1.09,0.44
			c0.42,0,0.74-0.17,0.98-0.5c0.24-0.34,0.35-0.8,0.35-1.39c0-0.6-0.12-1.06-0.35-1.38C89.31,140.07,88.98,139.91,88.55,139.91z"
          />
          <path       className={clsx(inView && classes.animation, classes.st1)} d="M92.66,144.2h-0.73v-6.84h0.73V144.2z" />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M96.24,144.28c-0.71,0-1.27-0.22-1.69-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6c0.35,0.4,0.53,0.92,0.53,1.57v0.46H94.7c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.15,0.44c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24
			C96.85,144.26,96.57,144.28,96.24,144.28z M96.05,139.9c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C96.72,140.03,96.43,139.9,96.05,139.9z"
          />
        </g>
        <path
                className={clsx(inView && classes.animation, classes.st1)}
          d="M55.64,156.19l-0.15-0.69h-0.04c-0.24,0.3-0.48,0.51-0.72,0.61c-0.24,0.11-0.54,0.16-0.89,0.16
		c-0.48,0-0.85-0.12-1.12-0.37c-0.27-0.25-0.41-0.6-0.41-1.05c0-0.97,0.78-1.48,2.33-1.53l0.82-0.03v-0.3
		c0-0.38-0.08-0.66-0.24-0.84s-0.42-0.27-0.78-0.27c-0.4,0-0.86,0.12-1.36,0.37l-0.22-0.56c0.24-0.13,0.5-0.23,0.78-0.3
		c0.28-0.07,0.57-0.11,0.85-0.11c0.57,0,1,0.13,1.28,0.38s0.42,0.66,0.42,1.23v3.29H55.64z M54,155.68c0.45,0,0.81-0.12,1.07-0.37
		c0.26-0.25,0.39-0.6,0.39-1.05v-0.44l-0.73,0.03c-0.58,0.02-1,0.11-1.25,0.27c-0.26,0.16-0.38,0.41-0.38,0.74
		c0,0.26,0.08,0.46,0.24,0.6C53.49,155.61,53.71,155.68,54,155.68z M59.86,151.94h-1.23v4.25H57.9v-4.25h-0.86v-0.33l0.86-0.26
		v-0.27c0-1.18,0.52-1.78,1.55-1.78c0.25,0,0.55,0.05,0.9,0.15l-0.19,0.58c-0.28-0.09-0.52-0.14-0.72-0.14
		c-0.28,0-0.48,0.09-0.61,0.27c-0.13,0.18-0.2,0.48-0.2,0.88v0.31h1.23V151.94z M62.91,151.94h-1.23v4.25h-0.73v-4.25h-0.86v-0.33
		l0.86-0.26v-0.27c0-1.18,0.52-1.78,1.55-1.78c0.25,0,0.55,0.05,0.9,0.15l-0.19,0.58c-0.28-0.09-0.52-0.14-0.72-0.14
		c-0.28,0-0.48,0.09-0.61,0.27c-0.13,0.18-0.2,0.48-0.2,0.88v0.31h1.23V151.94z M65.82,156.28c-0.71,0-1.27-0.22-1.69-0.65
		c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85s0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6
		c0.35,0.4,0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29c0.27,0.29,0.65,0.44,1.14,0.44
		c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24C66.43,156.26,66.15,156.28,65.82,156.28z M65.62,151.9
		c-0.39,0-0.7,0.13-0.93,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52c0-0.46-0.1-0.81-0.31-1.06C66.3,152.02,66.01,151.9,65.62,151.9z
		 M71.98,156.03c-0.32,0.17-0.73,0.25-1.22,0.25c-0.7,0-1.24-0.21-1.62-0.64c-0.38-0.43-0.57-1.04-0.57-1.82
		c0-0.81,0.19-1.43,0.58-1.87c0.39-0.44,0.94-0.66,1.66-0.66c0.23,0,0.46,0.02,0.69,0.07c0.23,0.05,0.41,0.11,0.54,0.18l-0.22,0.62
		c-0.16-0.06-0.34-0.12-0.53-0.16c-0.19-0.04-0.36-0.06-0.51-0.06c-0.98,0-1.47,0.62-1.47,1.87c0,0.59,0.12,1.05,0.36,1.36
		c0.24,0.32,0.59,0.47,1.06,0.47c0.4,0,0.81-0.09,1.23-0.26V156.03L71.98,156.03z M74.68,155.68c0.13,0,0.25-0.01,0.37-0.03
		c0.12-0.02,0.22-0.04,0.29-0.06v0.56c-0.08,0.04-0.2,0.07-0.35,0.09c-0.15,0.02-0.29,0.04-0.42,0.04c-0.93,0-1.4-0.49-1.4-1.47
		v-2.87h-0.69v-0.35l0.69-0.3l0.31-1.03h0.42v1.12h1.4v0.57h-1.4v2.83c0,0.29,0.07,0.51,0.21,0.67
		C74.25,155.6,74.44,155.68,74.68,155.68z M78.33,156.28c-0.71,0-1.27-0.22-1.69-0.65c-0.41-0.43-0.62-1.04-0.62-1.81
		c0-0.78,0.19-1.39,0.57-1.85s0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6c0.35,0.4,0.53,0.92,0.53,1.57v0.46h-3.32
		c0.01,0.57,0.16,0.99,0.43,1.29c0.27,0.29,0.65,0.44,1.14,0.44c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24
		C78.94,156.26,78.66,156.28,78.33,156.28z M78.13,151.9c-0.39,0-0.7,0.13-0.93,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
		c0-0.46-0.1-0.81-0.31-1.06C78.81,152.02,78.52,151.9,78.13,151.9z M84.63,155.55h-0.04c-0.34,0.49-0.84,0.73-1.51,0.73
		c-0.63,0-1.12-0.22-1.47-0.65c-0.35-0.43-0.53-1.04-0.53-1.84c0-0.79,0.18-1.41,0.53-1.85s0.84-0.66,1.47-0.66
		c0.65,0,1.15,0.24,1.5,0.71h0.06l-0.03-0.35l-0.02-0.34v-1.96h0.73v6.84h-0.59L84.63,155.55z M83.17,155.67
		c0.5,0,0.86-0.14,1.08-0.41c0.22-0.27,0.34-0.71,0.34-1.31v-0.15c0-0.68-0.11-1.17-0.34-1.46c-0.23-0.29-0.59-0.44-1.09-0.44
		c-0.43,0-0.76,0.17-0.98,0.5c-0.23,0.33-0.34,0.8-0.34,1.41c0,0.62,0.11,1.08,0.34,1.39C82.4,155.51,82.73,155.67,83.17,155.67z
		 M89.93,152.02c0.34-0.48,0.84-0.72,1.51-0.72c0.63,0,1.12,0.22,1.47,0.65c0.35,0.43,0.53,1.04,0.53,1.83s-0.18,1.41-0.53,1.84
		c-0.35,0.44-0.84,0.66-1.47,0.66c-0.31,0-0.6-0.06-0.86-0.17s-0.48-0.29-0.65-0.53h-0.05l-0.15,0.62H89.2v-6.84h0.73v1.66
		c0,0.37-0.01,0.71-0.04,1H89.93L89.93,152.02z M91.34,151.91c-0.5,0-0.86,0.14-1.08,0.43s-0.33,0.77-0.33,1.44s0.11,1.16,0.34,1.45
		c0.23,0.29,0.59,0.44,1.09,0.44c0.45,0,0.78-0.16,1-0.49c0.22-0.33,0.33-0.8,0.33-1.41c0-0.63-0.11-1.09-0.33-1.4
		S91.8,151.91,91.34,151.91z M93.96,151.38h0.78l1.05,2.75c0.23,0.63,0.37,1.08,0.43,1.36h0.04c0.04-0.15,0.12-0.4,0.24-0.77
		c0.12-0.36,0.52-1.47,1.19-3.34h0.78l-2.07,5.48c-0.21,0.54-0.44,0.93-0.72,1.15c-0.27,0.23-0.61,0.34-1.01,0.34
		c-0.22,0-0.44-0.02-0.66-0.07v-0.58c0.16,0.04,0.34,0.05,0.54,0.05c0.5,0,0.86-0.28,1.07-0.84l0.27-0.69L93.96,151.38z"
        />
        <g>
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M29.39,168.28c-0.71,0-1.27-0.22-1.68-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6c0.35,0.4,0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.14,0.44c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24
			C29.99,168.25,29.72,168.28,29.39,168.28z M29.19,163.9c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C29.87,164.02,29.57,163.9,29.19,163.9z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M33.57,165.72l-1.67-2.35h0.83l1.27,1.85l1.27-1.85h0.82l-1.67,2.35l1.76,2.47h-0.83l-1.35-1.95l-1.36,1.95
			H31.8L33.57,165.72z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M38.68,167.68c0.13,0,0.25-0.01,0.37-0.03c0.12-0.02,0.22-0.04,0.29-0.06v0.56c-0.08,0.04-0.2,0.07-0.35,0.09
			c-0.15,0.02-0.29,0.04-0.42,0.04c-0.93,0-1.4-0.49-1.4-1.47v-2.87h-0.69v-0.35l0.69-0.3l0.31-1.03h0.42v1.12h1.4v0.57h-1.4v2.83
			c0,0.29,0.07,0.51,0.21,0.67S38.44,167.68,38.68,167.68z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M42.49,163.29c0.21,0,0.41,0.02,0.58,0.05l-0.1,0.68c-0.2-0.04-0.38-0.07-0.53-0.07c-0.39,0-0.72,0.16-1,0.47
			c-0.28,0.32-0.42,0.71-0.42,1.18v2.58H40.3v-4.82h0.6l0.08,0.89h0.04c0.18-0.31,0.39-0.55,0.65-0.72S42.19,163.29,42.49,163.29z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M46.01,168.28c-0.71,0-1.27-0.22-1.69-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6c0.35,0.4,0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.15,0.44c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24
			C46.61,168.25,46.33,168.28,46.01,168.28z M45.81,163.9c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C46.48,164.02,46.19,163.9,45.81,163.9z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M55.16,168.19v-3.13c0-0.38-0.08-0.67-0.25-0.86c-0.16-0.19-0.42-0.29-0.76-0.29c-0.45,0-0.79,0.13-1.01,0.39
			s-0.33,0.66-0.33,1.2v2.69h-0.73v-3.13c0-0.38-0.08-0.67-0.25-0.86c-0.16-0.19-0.42-0.29-0.77-0.29c-0.46,0-0.79,0.14-1,0.41
			c-0.21,0.27-0.32,0.72-0.32,1.35v2.53h-0.73v-4.82h0.59l0.12,0.66h0.04c0.14-0.23,0.33-0.42,0.58-0.55
			c0.25-0.13,0.53-0.2,0.84-0.2c0.75,0,1.25,0.27,1.48,0.82h0.04c0.14-0.25,0.35-0.45,0.62-0.6s0.58-0.22,0.93-0.22
			c0.54,0,0.95,0.14,1.22,0.42c0.27,0.28,0.41,0.73,0.41,1.34v3.14H55.16z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M59.43,168.28c-0.71,0-1.27-0.22-1.69-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6c0.35,0.4,0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.15,0.44c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24
			C60.03,168.25,59.75,168.28,59.43,168.28z M59.23,163.9c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C59.9,164.02,59.61,163.9,59.23,163.9z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M68.71,168.19l-0.88-2.83c-0.06-0.17-0.16-0.57-0.31-1.18h-0.04c-0.12,0.51-0.22,0.91-0.31,1.19l-0.91,2.82
			h-0.84l-1.31-4.82h0.76c0.31,1.21,0.55,2.13,0.71,2.76c0.16,0.63,0.26,1.06,0.28,1.28h0.04c0.03-0.17,0.08-0.38,0.16-0.65
			c0.07-0.26,0.13-0.48,0.19-0.63l0.88-2.76h0.79l0.86,2.76c0.16,0.5,0.28,0.93,0.33,1.27h0.04c0.01-0.11,0.04-0.27,0.09-0.49
			c0.05-0.22,0.36-1.4,0.92-3.55h0.76l-1.33,4.82H68.71z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M73.82,168.28c-0.71,0-1.27-0.22-1.69-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6c0.35,0.4,0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.15,0.44c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24
			C74.42,168.25,74.14,168.28,73.82,168.28z M73.62,163.9c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C74.29,164.02,74,163.9,73.62,163.9z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M79.79,168.19l-0.15-0.69h-0.04c-0.24,0.3-0.48,0.51-0.72,0.61c-0.24,0.11-0.54,0.16-0.89,0.16
			c-0.48,0-0.85-0.12-1.12-0.37c-0.27-0.25-0.41-0.6-0.41-1.05c0-0.97,0.78-1.48,2.33-1.53l0.82-0.03V165
			c0-0.38-0.08-0.66-0.24-0.84c-0.16-0.18-0.42-0.27-0.78-0.27c-0.4,0-0.86,0.12-1.36,0.37l-0.22-0.56c0.24-0.13,0.5-0.23,0.78-0.3
			c0.28-0.07,0.57-0.11,0.85-0.11c0.57,0,1,0.13,1.28,0.38c0.28,0.25,0.42,0.66,0.42,1.23v3.29H79.79z M78.14,167.68
			c0.45,0,0.81-0.12,1.07-0.37c0.26-0.25,0.39-0.6,0.39-1.05v-0.44l-0.73,0.03c-0.58,0.02-1,0.11-1.25,0.27
			c-0.26,0.16-0.38,0.41-0.38,0.74c0,0.26,0.08,0.46,0.24,0.6C77.63,167.61,77.86,167.68,78.14,167.68z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M83.39,167.68c0.13,0,0.25-0.01,0.37-0.03c0.12-0.02,0.21-0.04,0.29-0.06v0.56c-0.08,0.04-0.2,0.07-0.35,0.09
			c-0.15,0.02-0.29,0.04-0.42,0.04c-0.93,0-1.4-0.49-1.4-1.47v-2.87H81.2v-0.35l0.69-0.3l0.31-1.03h0.42v1.12h1.4v0.57h-1.4v2.83
			c0,0.29,0.07,0.51,0.21,0.67S83.15,167.68,83.39,167.68z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M88.31,168.19v-3.12c0-0.39-0.09-0.69-0.27-0.88s-0.46-0.29-0.84-0.29c-0.51,0-0.88,0.14-1.11,0.41
			c-0.23,0.28-0.35,0.73-0.35,1.35v2.52h-0.73v-6.84h0.73v2.07c0,0.25-0.01,0.46-0.04,0.62h0.04c0.14-0.23,0.35-0.41,0.61-0.55
			c0.26-0.13,0.57-0.2,0.91-0.2c0.59,0,1.03,0.14,1.33,0.42c0.29,0.28,0.44,0.72,0.44,1.33v3.14H88.31z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M92.57,168.28c-0.71,0-1.27-0.22-1.69-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6c0.35,0.4,0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.15,0.44c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24
			C93.17,168.25,92.9,168.28,92.57,168.28z M92.37,163.9c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C93.05,164.02,92.75,163.9,92.37,163.9z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M97.78,163.29c0.21,0,0.41,0.02,0.58,0.05l-0.1,0.68c-0.2-0.04-0.38-0.07-0.53-0.07c-0.39,0-0.72,0.16-1,0.47
			c-0.28,0.32-0.42,0.71-0.42,1.18v2.58h-0.73v-4.82h0.6l0.08,0.89h0.04c0.18-0.31,0.39-0.55,0.65-0.72S97.48,163.29,97.78,163.29z"
          />
        </g>
        <g>
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M66.08,180.28c-0.31,0-0.6-0.06-0.86-0.17c-0.26-0.12-0.48-0.29-0.65-0.53h-0.05
			c0.04,0.28,0.05,0.55,0.05,0.8v1.98h-0.73v-6.98h0.59l0.1,0.66h0.04c0.19-0.26,0.41-0.45,0.65-0.57s0.54-0.18,0.86-0.18
			c0.64,0,1.13,0.22,1.48,0.65c0.35,0.44,0.52,1.05,0.52,1.84c0,0.79-0.18,1.41-0.53,1.84C67.2,180.06,66.71,180.28,66.08,180.28z
			 M65.98,175.9c-0.49,0-0.85,0.14-1.07,0.41s-0.33,0.71-0.34,1.3v0.16c0,0.68,0.11,1.16,0.34,1.45c0.23,0.29,0.59,0.44,1.09,0.44
			c0.42,0,0.74-0.17,0.98-0.5c0.24-0.34,0.35-0.8,0.35-1.39c0-0.6-0.12-1.06-0.35-1.38C66.74,176.06,66.41,175.9,65.98,175.9z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M72.32,180.19l-0.14-0.69h-0.04c-0.24,0.3-0.48,0.51-0.72,0.61c-0.24,0.11-0.54,0.16-0.89,0.16
			c-0.48,0-0.85-0.12-1.12-0.37c-0.27-0.25-0.41-0.6-0.41-1.05c0-0.97,0.78-1.48,2.33-1.53l0.82-0.03V177
			c0-0.38-0.08-0.66-0.24-0.84c-0.16-0.18-0.42-0.27-0.78-0.27c-0.4,0-0.86,0.12-1.36,0.37l-0.22-0.56c0.24-0.13,0.5-0.23,0.78-0.3
			c0.28-0.07,0.57-0.11,0.85-0.11c0.57,0,1,0.13,1.28,0.38c0.28,0.25,0.42,0.66,0.42,1.23v3.29H72.32z M70.67,179.67
			c0.45,0,0.81-0.12,1.07-0.37c0.26-0.25,0.39-0.6,0.39-1.05v-0.44l-0.73,0.03c-0.58,0.02-1,0.11-1.25,0.27
			c-0.26,0.16-0.38,0.41-0.38,0.74c0,0.26,0.08,0.46,0.24,0.6C70.16,179.6,70.38,179.67,70.67,179.67z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M75.92,179.67c0.13,0,0.25-0.01,0.37-0.03c0.12-0.02,0.22-0.04,0.29-0.06v0.56c-0.08,0.04-0.2,0.07-0.35,0.09
			c-0.15,0.02-0.29,0.04-0.42,0.04c-0.93,0-1.4-0.49-1.4-1.47v-2.87h-0.69v-0.35l0.69-0.3l0.31-1.03h0.42v1.12h1.4v0.57h-1.4v2.83
			c0,0.29,0.07,0.51,0.21,0.67S75.68,179.67,75.92,179.67z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M79.1,179.67c0.13,0,0.25-0.01,0.37-0.03c0.12-0.02,0.21-0.04,0.29-0.06v0.56c-0.08,0.04-0.2,0.07-0.35,0.09
			c-0.15,0.02-0.29,0.04-0.42,0.04c-0.93,0-1.4-0.49-1.4-1.47v-2.87H76.9v-0.35l0.69-0.3l0.31-1.03h0.42v1.12h1.4v0.57h-1.4v2.83
			c0,0.29,0.07,0.51,0.21,0.67S78.86,179.67,79.1,179.67z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M82.75,180.28c-0.71,0-1.27-0.22-1.68-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6c0.35,0.4,0.53,0.92,0.53,1.57v0.46H81.2c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.14,0.44c0.52,0,1.03-0.11,1.54-0.33v0.65c-0.26,0.11-0.5,0.19-0.73,0.24
			C83.35,180.25,83.08,180.28,82.75,180.28z M82.55,175.89c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C83.23,176.02,82.94,175.89,82.55,175.89z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M87.96,175.28c0.21,0,0.41,0.02,0.58,0.05l-0.1,0.68c-0.2-0.04-0.38-0.07-0.53-0.07c-0.39,0-0.72,0.16-1,0.47
			c-0.28,0.32-0.42,0.71-0.42,1.18v2.58h-0.73v-4.82h0.6l0.08,0.89h0.04c0.18-0.31,0.39-0.55,0.65-0.72S87.66,175.28,87.96,175.28z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M92.74,180.19v-3.12c0-0.39-0.09-0.69-0.27-0.88s-0.46-0.29-0.84-0.29c-0.5,0-0.87,0.14-1.11,0.41
			s-0.35,0.72-0.35,1.35v2.53h-0.73v-4.82h0.59l0.12,0.66h0.04c0.15-0.24,0.36-0.42,0.63-0.55c0.27-0.13,0.57-0.2,0.9-0.2
			c0.58,0,1.02,0.14,1.31,0.42c0.29,0.28,0.44,0.73,0.44,1.34v3.14H92.74z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M98.07,178.87c0,0.45-0.17,0.79-0.5,1.04s-0.8,0.37-1.41,0.37c-0.64,0-1.14-0.1-1.49-0.3v-0.68
			c0.23,0.12,0.48,0.21,0.75,0.28c0.26,0.07,0.52,0.1,0.77,0.1c0.38,0,0.67-0.06,0.88-0.18c0.21-0.12,0.31-0.31,0.31-0.56
			c0-0.19-0.08-0.35-0.24-0.48c-0.16-0.13-0.48-0.29-0.95-0.47c-0.45-0.17-0.77-0.31-0.96-0.44c-0.19-0.12-0.33-0.27-0.42-0.42
			c-0.09-0.16-0.14-0.35-0.14-0.57c0-0.39,0.16-0.7,0.48-0.93c0.32-0.23,0.76-0.34,1.31-0.34c0.52,0,1.03,0.11,1.52,0.32l-0.26,0.59
			c-0.48-0.2-0.92-0.3-1.31-0.3c-0.35,0-0.61,0.05-0.78,0.16s-0.26,0.26-0.26,0.45c0,0.13,0.03,0.24,0.1,0.33
			c0.07,0.09,0.17,0.18,0.32,0.26s0.43,0.2,0.84,0.36c0.57,0.21,0.96,0.42,1.16,0.63C97.97,178.29,98.07,178.55,98.07,178.87z"
          />
        </g>
        <g>
          <path
            className={clsx(inView && classes.animation, classes.st0)}
            d="M88.23,36.75h-8.2v-1.47l3.12-3.14c0.92-0.94,1.53-1.61,1.83-2.01c0.3-0.39,0.52-0.76,0.66-1.11
			c0.14-0.35,0.21-0.72,0.21-1.12c0-0.55-0.16-0.98-0.49-1.29c-0.33-0.31-0.78-0.47-1.36-0.47c-0.46,0-0.91,0.09-1.34,0.26
			c-0.43,0.17-0.93,0.48-1.5,0.93l-1.05-1.28c0.67-0.57,1.33-0.97,1.96-1.21c0.63-0.24,1.31-0.36,2.03-0.36
			c1.12,0,2.03,0.29,2.71,0.88c0.68,0.59,1.02,1.38,1.02,2.37c0,0.55-0.1,1.06-0.29,1.56c-0.2,0.49-0.5,1-0.9,1.52
			c-0.41,0.52-1.08,1.23-2.02,2.11l-2.1,2.03v0.08h5.74V36.75z"
          />
          <path
            className={clsx(inView && classes.animation, classes.st0)}
            d="M98.33,34.11H96.7v2.64h-1.89v-2.64h-5.53v-1.5l5.53-7.99h1.89v7.87h1.63V34.11z M94.81,32.5v-3.04
			c0-1.08,0.03-1.97,0.08-2.66h-0.07c-0.15,0.36-0.4,0.81-0.73,1.32l-3,4.37H94.81z"
          />
          <path
            className={clsx(inView && classes.animation, classes.st0)}
            d="M106.45,36.75l-3.51-10.1h-0.07c0.09,1.5,0.14,2.91,0.14,4.22v5.88h-1.79V24.65h2.79l3.36,9.62h0.05
			l3.46-9.62h2.8v12.09h-1.9v-5.98c0-0.6,0.02-1.38,0.05-2.35c0.03-0.96,0.06-1.55,0.08-1.75h-0.07l-3.63,10.08H106.45z"
          />
        </g>
        <g>
          <path
            className={clsx(inView && classes.animation, classes.st1)}
            d="M29.49,51.23l-0.14-0.69h-0.04c-0.24,0.3-0.48,0.51-0.72,0.61c-0.24,0.11-0.54,0.16-0.89,0.16
			c-0.48,0-0.85-0.12-1.12-0.37c-0.27-0.25-0.41-0.6-0.41-1.05c0-0.97,0.78-1.48,2.33-1.53l0.82-0.03v-0.3
			c0-0.38-0.08-0.66-0.24-0.84c-0.16-0.18-0.42-0.27-0.78-0.27c-0.4,0-0.86,0.12-1.36,0.37l-0.22-0.56c0.24-0.13,0.5-0.23,0.78-0.3
			c0.28-0.07,0.57-0.11,0.85-0.11c0.57,0,1,0.13,1.28,0.38c0.28,0.25,0.42,0.66,0.42,1.23v3.29H29.49z M27.85,50.71
			c0.45,0,0.81-0.12,1.07-0.37c0.26-0.25,0.39-0.6,0.39-1.05v-0.44l-0.73,0.03c-0.58,0.02-1,0.11-1.25,0.27
			c-0.26,0.16-0.38,0.41-0.38,0.74c0,0.26,0.08,0.46,0.24,0.6C27.34,50.64,27.56,50.71,27.85,50.71z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M33.46,51.31c-0.7,0-1.24-0.21-1.62-0.64c-0.38-0.43-0.57-1.04-0.57-1.82c0-0.81,0.19-1.43,0.58-1.87
			c0.39-0.44,0.94-0.66,1.66-0.66c0.23,0,0.46,0.02,0.69,0.07s0.41,0.11,0.54,0.18l-0.22,0.62c-0.16-0.06-0.34-0.12-0.53-0.16
			s-0.36-0.06-0.51-0.06c-0.98,0-1.47,0.62-1.47,1.87c0,0.59,0.12,1.05,0.36,1.36c0.24,0.32,0.59,0.47,1.06,0.47
			c0.4,0,0.81-0.09,1.23-0.26v0.65C34.36,51.23,33.95,51.31,33.46,51.31z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M36.51,46.41v3.12c0,0.39,0.09,0.69,0.27,0.88s0.46,0.29,0.84,0.29c0.5,0,0.87-0.14,1.11-0.41
			c0.23-0.28,0.35-0.73,0.35-1.35v-2.53h0.73v4.82h-0.6l-0.11-0.65h-0.04c-0.15,0.24-0.36,0.42-0.62,0.54
			c-0.27,0.13-0.57,0.19-0.91,0.19c-0.59,0-1.03-0.14-1.32-0.42c-0.29-0.28-0.44-0.72-0.44-1.34v-3.15H36.51z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M42.9,50.71c0.13,0,0.25-0.01,0.37-0.03c0.12-0.02,0.22-0.04,0.29-0.06v0.56c-0.08,0.04-0.2,0.07-0.35,0.09
			c-0.15,0.02-0.29,0.04-0.42,0.04c-0.93,0-1.4-0.49-1.4-1.47v-2.87h-0.69v-0.35l0.69-0.3l0.31-1.03h0.42v1.12h1.4v0.57h-1.4v2.83
			c0,0.29,0.07,0.51,0.21,0.67S42.66,50.71,42.9,50.71z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M46.56,51.31c-0.71,0-1.27-0.22-1.69-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6s0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.15,0.44c0.52,0,1.03-0.11,1.54-0.33V51c-0.26,0.11-0.5,0.19-0.73,0.24
			C47.16,51.29,46.88,51.31,46.56,51.31z M46.36,46.93c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C47.03,47.06,46.74,46.93,46.36,46.93z"
          />
          <path       className={clsx(inView && classes.animation, classes.st1)} d="M50.3,51.23h-0.73v-6.84h0.73V51.23z" />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M51.09,46.41h0.78l1.05,2.75c0.23,0.63,0.38,1.08,0.43,1.36h0.04c0.04-0.15,0.12-0.4,0.24-0.77
			c0.12-0.36,0.52-1.47,1.19-3.34h0.78l-2.07,5.48c-0.21,0.54-0.44,0.93-0.72,1.15c-0.27,0.23-0.61,0.34-1.01,0.34
			c-0.22,0-0.44-0.02-0.66-0.07v-0.58c0.16,0.04,0.34,0.05,0.54,0.05c0.5,0,0.86-0.28,1.07-0.84l0.27-0.69L51.09,46.41z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M60.89,46.98h-1.23v4.25h-0.73v-4.25h-0.86v-0.33l0.86-0.26v-0.27c0-1.18,0.52-1.78,1.55-1.78
			c0.25,0,0.55,0.05,0.9,0.15l-0.19,0.58c-0.28-0.09-0.52-0.14-0.72-0.14c-0.28,0-0.48,0.09-0.61,0.27c-0.13,0.18-0.2,0.48-0.2,0.88
			v0.31h1.23V46.98z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M65.93,48.81c0,0.79-0.2,1.4-0.59,1.84s-0.94,0.66-1.64,0.66c-0.43,0-0.81-0.1-1.15-0.3s-0.59-0.49-0.77-0.87
			s-0.27-0.82-0.27-1.33c0-0.79,0.2-1.4,0.59-1.83s0.94-0.66,1.63-0.66c0.67,0,1.21,0.22,1.61,0.67
			C65.73,47.44,65.93,48.05,65.93,48.81z M62.26,48.81c0,0.62,0.12,1.08,0.37,1.41s0.61,0.48,1.09,0.48s0.84-0.16,1.09-0.48
			c0.25-0.32,0.37-0.79,0.37-1.41c0-0.61-0.12-1.08-0.37-1.4c-0.25-0.32-0.61-0.48-1.1-0.48c-0.48,0-0.84,0.16-1.08,0.47
			S62.26,48.19,62.26,48.81z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M71.37,48.81c0,0.79-0.2,1.4-0.59,1.84s-0.94,0.66-1.64,0.66c-0.43,0-0.81-0.1-1.15-0.3s-0.59-0.49-0.77-0.87
			s-0.27-0.82-0.27-1.33c0-0.79,0.2-1.4,0.59-1.83s0.94-0.66,1.63-0.66c0.67,0,1.21,0.22,1.61,0.67
			C71.17,47.44,71.37,48.05,71.37,48.81z M67.7,48.81c0,0.62,0.12,1.08,0.37,1.41s0.61,0.48,1.08,0.48s0.84-0.16,1.09-0.48
			c0.25-0.32,0.37-0.79,0.37-1.41c0-0.61-0.12-1.08-0.37-1.4c-0.25-0.32-0.61-0.48-1.1-0.48c-0.48,0-0.84,0.16-1.08,0.47
			S67.7,48.19,67.7,48.81z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M75.92,50.58h-0.04c-0.34,0.49-0.84,0.73-1.51,0.73c-0.63,0-1.12-0.22-1.47-0.65
			c-0.35-0.43-0.53-1.04-0.53-1.84s0.18-1.41,0.53-1.85s0.84-0.66,1.47-0.66c0.65,0,1.15,0.24,1.5,0.71h0.06l-0.03-0.35l-0.02-0.34
			v-1.96h0.73v6.84h-0.59L75.92,50.58z M74.46,50.7c0.5,0,0.86-0.14,1.08-0.41c0.22-0.27,0.34-0.71,0.34-1.31v-0.15
			c0-0.68-0.11-1.17-0.34-1.46c-0.23-0.29-0.59-0.44-1.09-0.44c-0.43,0-0.76,0.17-0.98,0.5c-0.23,0.33-0.34,0.8-0.34,1.41
			c0,0.62,0.11,1.08,0.34,1.39S74.03,50.7,74.46,50.7z"
          />
          <path       className={clsx(inView && classes.animation, classes.st1)} d="M77.76,49.15v-0.67h2.16v0.67H77.76z" />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M80.99,45.1c0-0.17,0.04-0.29,0.12-0.37s0.18-0.12,0.31-0.12c0.12,0,0.22,0.04,0.3,0.12s0.13,0.2,0.13,0.36
			s-0.04,0.29-0.13,0.37c-0.08,0.08-0.19,0.12-0.3,0.12c-0.12,0-0.23-0.04-0.31-0.12C81.04,45.39,80.99,45.27,80.99,45.1z
			 M81.79,51.23h-0.73v-4.82h0.73V51.23z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M86.63,51.23v-3.12c0-0.39-0.09-0.69-0.27-0.88s-0.46-0.29-0.84-0.29c-0.5,0-0.87,0.14-1.11,0.41
			s-0.35,0.72-0.35,1.35v2.53h-0.73v-4.82h0.59l0.12,0.66h0.04c0.15-0.24,0.36-0.42,0.63-0.55c0.27-0.13,0.57-0.2,0.9-0.2
			c0.58,0,1.02,0.14,1.31,0.42s0.44,0.73,0.44,1.34v3.14H86.63z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M91.96,49.91c0,0.45-0.17,0.79-0.5,1.04s-0.8,0.36-1.41,0.36c-0.64,0-1.14-0.1-1.49-0.3v-0.68
			c0.23,0.12,0.48,0.21,0.74,0.28c0.27,0.07,0.52,0.1,0.77,0.1c0.38,0,0.67-0.06,0.88-0.18s0.31-0.31,0.31-0.56
			c0-0.19-0.08-0.35-0.24-0.48c-0.16-0.13-0.48-0.29-0.95-0.47c-0.45-0.17-0.77-0.31-0.96-0.44c-0.19-0.12-0.33-0.27-0.42-0.42
			c-0.09-0.16-0.14-0.35-0.14-0.57c0-0.39,0.16-0.7,0.48-0.93s0.76-0.34,1.31-0.34c0.52,0,1.03,0.11,1.52,0.32l-0.26,0.59
			c-0.48-0.2-0.92-0.3-1.31-0.3c-0.35,0-0.61,0.05-0.78,0.16s-0.26,0.26-0.26,0.45c0,0.13,0.03,0.24,0.1,0.33
			c0.07,0.09,0.17,0.18,0.32,0.26s0.43,0.2,0.84,0.36c0.57,0.21,0.96,0.42,1.16,0.63C91.86,49.33,91.96,49.59,91.96,49.91z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M95.18,51.31c-0.71,0-1.27-0.22-1.68-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6s0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.14,0.44c0.52,0,1.03-0.11,1.54-0.33V51c-0.26,0.11-0.5,0.19-0.73,0.24
			C95.79,51.29,95.51,51.31,95.18,51.31z M94.99,46.93c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C95.66,47.06,95.37,46.93,94.99,46.93z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M100.12,51.31c-0.7,0-1.24-0.21-1.62-0.64c-0.38-0.43-0.57-1.04-0.57-1.82c0-0.81,0.19-1.43,0.58-1.87
			c0.39-0.44,0.94-0.66,1.66-0.66c0.23,0,0.46,0.02,0.69,0.07s0.41,0.11,0.54,0.18l-0.22,0.62c-0.16-0.06-0.34-0.12-0.53-0.16
			s-0.36-0.06-0.5-0.06c-0.98,0-1.47,0.62-1.47,1.87c0,0.59,0.12,1.05,0.36,1.36c0.24,0.32,0.59,0.47,1.06,0.47
			c0.4,0,0.81-0.09,1.24-0.26v0.65C101.02,51.23,100.61,51.31,100.12,51.31z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M103.17,46.41v3.12c0,0.39,0.09,0.69,0.27,0.88s0.46,0.29,0.84,0.29c0.5,0,0.87-0.14,1.11-0.41
			c0.23-0.28,0.35-0.73,0.35-1.35v-2.53h0.73v4.82h-0.6l-0.11-0.65h-0.04c-0.15,0.24-0.36,0.42-0.62,0.54
			c-0.27,0.13-0.57,0.19-0.91,0.19c-0.59,0-1.02-0.14-1.32-0.42c-0.29-0.28-0.44-0.72-0.44-1.34v-3.15H103.17z"
          />
          <path
                className={clsx(inView && classes.animation, classes.st1)}

            d="M110.2,46.32c0.21,0,0.41,0.02,0.58,0.05l-0.1,0.68c-0.2-0.04-0.38-0.07-0.53-0.07c-0.39,0-0.72,0.16-1,0.47
			c-0.28,0.32-0.42,0.71-0.42,1.18v2.58h-0.73v-4.82h0.6l0.08,0.89h0.04c0.18-0.31,0.39-0.56,0.65-0.73S109.9,46.32,110.2,46.32z"
          />
          <path
                className={clsx(inView && classes.animation, classes.st1)}
 
            d="M113.72,51.31c-0.71,0-1.27-0.22-1.69-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6s0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.15,0.44c0.52,0,1.03-0.11,1.54-0.33V51c-0.26,0.11-0.5,0.19-0.73,0.24
			C114.32,51.29,114.04,51.31,113.72,51.31z M113.52,46.93c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C114.19,47.06,113.9,46.93,113.52,46.93z"
          />
        </g>
        <path
          className={clsx(inView && classes.animation, classes.st1)}
          d="M41.22,63.31c-0.31,0-0.6-0.06-0.86-0.17s-0.48-0.29-0.65-0.53h-0.05c0.04,0.28,0.05,0.55,0.05,0.8v1.98h-0.73
		v-6.98h0.59l0.1,0.66h0.04c0.19-0.26,0.41-0.45,0.65-0.57c0.25-0.12,0.53-0.18,0.86-0.18c0.64,0,1.13,0.22,1.48,0.65
		c0.35,0.44,0.52,1.05,0.52,1.84c0,0.79-0.18,1.41-0.53,1.84C42.34,63.09,41.85,63.31,41.22,63.31z M41.12,58.94
		c-0.49,0-0.85,0.14-1.07,0.41s-0.33,0.71-0.34,1.3v0.16c0,0.68,0.11,1.16,0.34,1.45c0.23,0.29,0.59,0.44,1.09,0.44
		c0.42,0,0.74-0.17,0.98-0.51c0.24-0.34,0.35-0.8,0.35-1.39c0-0.6-0.12-1.06-0.35-1.38C41.88,59.1,41.54,58.94,41.12,58.94z
		 M46.53,63.31c-0.71,0-1.27-0.22-1.69-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85s0.9-0.69,1.54-0.69
		c0.6,0,1.08,0.2,1.43,0.6c0.35,0.4,0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29c0.27,0.29,0.65,0.44,1.14,0.44
		c0.52,0,1.03-0.11,1.54-0.33V63c-0.26,0.11-0.5,0.19-0.73,0.24C47.13,63.29,46.86,63.31,46.53,63.31z M46.33,58.93
		c-0.39,0-0.7,0.13-0.93,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52c0-0.46-0.1-0.81-0.31-1.06C47.01,59.05,46.72,58.93,46.33,58.93z
		 M53.7,60.81c0,0.79-0.2,1.4-0.59,1.84c-0.4,0.44-0.94,0.66-1.64,0.66c-0.43,0-0.81-0.1-1.15-0.3s-0.59-0.49-0.77-0.87
		c-0.18-0.38-0.27-0.82-0.27-1.33c0-0.79,0.2-1.4,0.59-1.83c0.39-0.44,0.94-0.66,1.63-0.66c0.67,0,1.21,0.22,1.61,0.67
		C53.51,59.44,53.7,60.05,53.7,60.81z M50.03,60.81c0,0.62,0.12,1.08,0.37,1.41c0.25,0.32,0.61,0.48,1.09,0.48
		c0.48,0,0.84-0.16,1.09-0.48c0.25-0.32,0.37-0.79,0.37-1.41c0-0.61-0.12-1.08-0.37-1.4c-0.25-0.32-0.61-0.48-1.1-0.48
		c-0.48,0-0.84,0.16-1.08,0.47C50.16,59.72,50.03,60.19,50.03,60.81z M57.22,63.31c-0.31,0-0.6-0.06-0.86-0.17s-0.48-0.29-0.65-0.53
		h-0.05c0.04,0.28,0.05,0.55,0.05,0.8v1.98h-0.73v-6.98h0.59l0.1,0.66h0.04c0.19-0.26,0.41-0.45,0.65-0.57
		c0.25-0.12,0.53-0.18,0.86-0.18c0.64,0,1.13,0.22,1.48,0.65c0.35,0.44,0.52,1.05,0.52,1.84c0,0.79-0.18,1.41-0.53,1.84
		C58.34,63.09,57.85,63.31,57.22,63.31z M57.12,58.94c-0.49,0-0.85,0.14-1.07,0.41s-0.33,0.71-0.34,1.3v0.16
		c0,0.68,0.11,1.16,0.34,1.45c0.23,0.29,0.59,0.44,1.09,0.44c0.42,0,0.74-0.17,0.98-0.51c0.24-0.34,0.35-0.8,0.35-1.39
		c0-0.6-0.12-1.06-0.35-1.38C57.88,59.1,57.55,58.94,57.12,58.94z M61.23,63.22H60.5v-6.84h0.73V63.22z M64.81,63.31
		c-0.71,0-1.27-0.22-1.69-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85s0.9-0.69,1.54-0.69
		c0.6,0,1.08,0.2,1.43,0.6c0.35,0.4,0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29c0.27,0.29,0.65,0.44,1.14,0.44
		c0.52,0,1.03-0.11,1.54-0.33V63c-0.26,0.11-0.5,0.19-0.73,0.24C65.41,63.29,65.14,63.31,64.81,63.31z M64.61,58.93
		c-0.39,0-0.7,0.13-0.93,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52c0-0.46-0.1-0.81-0.31-1.06C65.29,59.05,64.99,58.93,64.61,58.93z
		 M73.13,63.22l-0.15-0.69h-0.04c-0.24,0.3-0.48,0.51-0.72,0.61c-0.24,0.11-0.54,0.16-0.89,0.16c-0.48,0-0.85-0.12-1.12-0.37
		c-0.27-0.25-0.41-0.6-0.41-1.05c0-0.97,0.78-1.48,2.33-1.53l0.82-0.03v-0.3c0-0.38-0.08-0.66-0.24-0.84s-0.42-0.27-0.78-0.27
		c-0.4,0-0.86,0.12-1.36,0.37l-0.22-0.56c0.24-0.13,0.5-0.23,0.78-0.3c0.28-0.07,0.57-0.11,0.85-0.11c0.57,0,1,0.13,1.28,0.38
		s0.42,0.66,0.42,1.23v3.29H73.13z M71.48,62.71c0.45,0,0.81-0.12,1.07-0.37c0.26-0.25,0.39-0.6,0.39-1.05v-0.44l-0.73,0.03
		c-0.58,0.02-1,0.11-1.25,0.27c-0.26,0.16-0.38,0.41-0.38,0.74c0,0.26,0.08,0.46,0.24,0.6C70.97,62.64,71.19,62.71,71.48,62.71z
		 M77.34,58.97h-1.23v4.25h-0.73v-4.25h-0.86v-0.33l0.86-0.26v-0.27c0-1.18,0.52-1.78,1.55-1.78c0.25,0,0.55,0.05,0.9,0.15
		l-0.19,0.58c-0.28-0.09-0.52-0.14-0.72-0.14c-0.28,0-0.48,0.09-0.61,0.27c-0.13,0.18-0.2,0.48-0.2,0.88v0.31h1.23V58.97z
		 M80.39,58.97h-1.23v4.25h-0.73v-4.25h-0.86v-0.33l0.86-0.26v-0.27c0-1.18,0.52-1.78,1.55-1.78c0.25,0,0.55,0.05,0.9,0.15
		l-0.19,0.58c-0.28-0.09-0.52-0.14-0.72-0.14c-0.28,0-0.48,0.09-0.61,0.27c-0.13,0.18-0.2,0.48-0.2,0.88v0.31h1.23V58.97z
		 M83.31,63.31c-0.71,0-1.27-0.22-1.69-0.65C81.21,62.23,81,61.63,81,60.85c0-0.78,0.19-1.39,0.57-1.85s0.9-0.69,1.54-0.69
		c0.6,0,1.08,0.2,1.43,0.6c0.35,0.4,0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29c0.27,0.29,0.65,0.44,1.14,0.44
		c0.52,0,1.03-0.11,1.54-0.33V63c-0.26,0.11-0.5,0.19-0.73,0.24C83.91,63.29,83.63,63.31,83.31,63.31z M83.11,58.93
		c-0.39,0-0.7,0.13-0.93,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52c0-0.46-0.1-0.81-0.31-1.06C83.78,59.05,83.49,58.93,83.11,58.93z
		 M89.46,63.06c-0.32,0.17-0.73,0.25-1.22,0.25c-0.7,0-1.24-0.21-1.62-0.64c-0.38-0.43-0.57-1.04-0.57-1.82
		c0-0.81,0.19-1.43,0.58-1.87c0.39-0.44,0.94-0.66,1.66-0.66c0.23,0,0.46,0.02,0.69,0.07c0.23,0.05,0.41,0.11,0.54,0.18l-0.22,0.62
		c-0.16-0.06-0.34-0.12-0.53-0.16c-0.19-0.04-0.36-0.06-0.51-0.06c-0.98,0-1.47,0.62-1.47,1.87c0,0.59,0.12,1.05,0.36,1.36
		c0.24,0.32,0.59,0.47,1.06,0.47c0.4,0,0.81-0.09,1.23-0.26V63.06L89.46,63.06z M92.16,62.71c0.13,0,0.25-0.01,0.37-0.03
		c0.12-0.02,0.22-0.04,0.29-0.06v0.56c-0.08,0.04-0.2,0.07-0.35,0.09c-0.15,0.02-0.29,0.04-0.42,0.04c-0.93,0-1.4-0.49-1.4-1.47
		v-2.87h-0.69v-0.35l0.69-0.3l0.31-1.03h0.42v1.12h1.4v0.57h-1.4v2.83c0,0.29,0.07,0.51,0.21,0.67
		C91.73,62.63,91.92,62.71,92.16,62.71z M95.82,63.31c-0.71,0-1.27-0.22-1.69-0.65c-0.41-0.43-0.62-1.04-0.62-1.81
		c0-0.78,0.19-1.39,0.57-1.85s0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6c0.35,0.4,0.53,0.92,0.53,1.57v0.46h-3.32
		c0.01,0.57,0.16,0.99,0.43,1.29c0.27,0.29,0.65,0.44,1.14,0.44c0.52,0,1.03-0.11,1.54-0.33V63c-0.26,0.11-0.5,0.19-0.73,0.24
		C96.42,63.29,96.14,63.31,95.82,63.31z M95.62,58.93c-0.39,0-0.7,0.13-0.93,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
		c0-0.46-0.1-0.81-0.31-1.06C96.29,59.05,96,58.93,95.62,58.93z M102.11,62.58h-0.04c-0.34,0.49-0.84,0.73-1.51,0.73
		c-0.63,0-1.12-0.22-1.47-0.65c-0.35-0.43-0.53-1.04-0.53-1.84c0-0.79,0.18-1.41,0.53-1.85s0.84-0.66,1.47-0.66
		c0.65,0,1.15,0.24,1.5,0.71h0.06l-0.03-0.35l-0.02-0.34v-1.96h0.73v6.84h-0.59L102.11,62.58z M100.65,62.7
		c0.5,0,0.86-0.14,1.08-0.41c0.22-0.27,0.34-0.71,0.34-1.31v-0.15c0-0.68-0.11-1.17-0.34-1.46c-0.23-0.29-0.59-0.44-1.09-0.44
		c-0.43,0-0.76,0.17-0.98,0.5c-0.23,0.33-0.34,0.8-0.34,1.41c0,0.62,0.11,1.08,0.34,1.39C99.88,62.54,100.21,62.7,100.65,62.7z
		 M107.42,59.05c0.34-0.48,0.84-0.72,1.51-0.72c0.63,0,1.12,0.22,1.47,0.65c0.35,0.43,0.53,1.04,0.53,1.83s-0.18,1.41-0.53,1.84
		c-0.35,0.44-0.84,0.66-1.47,0.66c-0.31,0-0.6-0.06-0.86-0.17s-0.48-0.29-0.65-0.53h-0.05l-0.15,0.62h-0.52v-6.84h0.73v1.66
		c0,0.37-0.01,0.71-0.04,1H107.42L107.42,59.05z M108.82,58.94c-0.5,0-0.86,0.14-1.08,0.43s-0.33,0.77-0.33,1.44
		s0.11,1.16,0.34,1.45c0.23,0.29,0.59,0.44,1.09,0.44c0.45,0,0.78-0.16,1-0.49c0.22-0.33,0.33-0.8,0.33-1.41
		c0-0.63-0.11-1.09-0.33-1.4S109.28,58.94,108.82,58.94z M111.44,58.41h0.78l1.05,2.75c0.23,0.63,0.37,1.08,0.43,1.36h0.04
		c0.04-0.15,0.12-0.4,0.24-0.77c0.12-0.36,0.52-1.47,1.19-3.34h0.78l-2.07,5.48c-0.21,0.54-0.44,0.93-0.72,1.15
		c-0.27,0.23-0.61,0.34-1.01,0.34c-0.22,0-0.44-0.02-0.66-0.07v-0.58c0.16,0.04,0.34,0.05,0.54,0.05c0.5,0,0.86-0.28,1.07-0.84
		l0.27-0.69L111.44,58.41z"
        />
        <g>
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M47.21,75.31c-0.71,0-1.27-0.22-1.68-0.65c-0.41-0.43-0.62-1.04-0.62-1.81c0-0.78,0.19-1.39,0.57-1.85
			c0.38-0.46,0.9-0.69,1.54-0.69c0.6,0,1.08,0.2,1.43,0.6s0.53,0.92,0.53,1.57v0.46h-3.32c0.01,0.57,0.16,0.99,0.43,1.29
			c0.27,0.29,0.65,0.44,1.14,0.44c0.52,0,1.03-0.11,1.54-0.33V75c-0.26,0.11-0.5,0.19-0.73,0.24
			C47.81,75.28,47.53,75.31,47.21,75.31z M47.01,70.93c-0.39,0-0.7,0.13-0.92,0.38c-0.23,0.25-0.37,0.6-0.41,1.05h2.52
			c0-0.46-0.1-0.81-0.31-1.06C47.68,71.05,47.39,70.93,47.01,70.93z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M52.15,75.31c-0.7,0-1.24-0.21-1.62-0.64c-0.38-0.43-0.57-1.04-0.57-1.82c0-0.81,0.19-1.43,0.58-1.87
			c0.39-0.44,0.94-0.66,1.66-0.66c0.23,0,0.46,0.02,0.69,0.07s0.41,0.11,0.54,0.18l-0.22,0.62c-0.16-0.06-0.34-0.12-0.53-0.16
			s-0.36-0.06-0.5-0.06c-0.98,0-1.47,0.62-1.47,1.87c0,0.59,0.12,1.05,0.36,1.36c0.24,0.32,0.59,0.47,1.06,0.47
			c0.4,0,0.81-0.09,1.24-0.26v0.65C53.04,75.22,52.64,75.31,52.15,75.31z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M58.66,72.81c0,0.79-0.2,1.4-0.59,1.84s-0.94,0.66-1.64,0.66c-0.43,0-0.81-0.1-1.15-0.3s-0.59-0.49-0.77-0.87
			s-0.27-0.82-0.27-1.33c0-0.79,0.2-1.4,0.59-1.83s0.94-0.66,1.63-0.66c0.67,0,1.21,0.22,1.61,0.67
			C58.46,71.44,58.66,72.04,58.66,72.81z M54.99,72.81c0,0.62,0.12,1.08,0.37,1.41s0.61,0.48,1.09,0.48s0.84-0.16,1.09-0.48
			c0.25-0.32,0.37-0.79,0.37-1.41c0-0.61-0.12-1.08-0.37-1.4c-0.25-0.32-0.61-0.48-1.1-0.48c-0.48,0-0.84,0.16-1.08,0.47
			S54.99,72.19,54.99,72.81z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M63.24,75.22V72.1c0-0.39-0.09-0.69-0.27-0.88s-0.46-0.29-0.84-0.29c-0.5,0-0.87,0.14-1.11,0.41
			s-0.35,0.72-0.35,1.35v2.53h-0.73V70.4h0.59l0.12,0.66h0.04c0.15-0.24,0.36-0.42,0.63-0.55c0.27-0.13,0.57-0.2,0.9-0.2
			c0.58,0,1.02,0.14,1.31,0.42s0.44,0.73,0.44,1.34v3.14H63.24z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M69.62,72.81c0,0.79-0.2,1.4-0.59,1.84s-0.94,0.66-1.64,0.66c-0.43,0-0.81-0.1-1.15-0.3s-0.59-0.49-0.77-0.87
			s-0.27-0.82-0.27-1.33c0-0.79,0.2-1.4,0.59-1.83s0.94-0.66,1.63-0.66c0.67,0,1.21,0.22,1.61,0.67
			C69.42,71.44,69.62,72.04,69.62,72.81z M65.95,72.81c0,0.62,0.12,1.08,0.37,1.41s0.61,0.48,1.09,0.48s0.84-0.16,1.09-0.48
			c0.25-0.32,0.37-0.79,0.37-1.41c0-0.61-0.12-1.08-0.37-1.4c-0.25-0.32-0.61-0.48-1.1-0.48c-0.48,0-0.84,0.16-1.08,0.47
			S65.95,72.19,65.95,72.81z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M77.04,75.22v-3.13c0-0.38-0.08-0.67-0.25-0.86c-0.16-0.19-0.42-0.29-0.76-0.29c-0.45,0-0.79,0.13-1.01,0.39
			s-0.33,0.66-0.33,1.2v2.69h-0.73v-3.13c0-0.38-0.08-0.67-0.25-0.86c-0.16-0.19-0.42-0.29-0.77-0.29c-0.46,0-0.79,0.14-1,0.41
			c-0.21,0.27-0.32,0.72-0.32,1.35v2.53H70.9V70.4h0.59l0.12,0.66h0.04c0.14-0.23,0.33-0.42,0.58-0.55c0.25-0.13,0.53-0.2,0.84-0.2
			c0.75,0,1.25,0.27,1.48,0.82h0.04c0.14-0.25,0.35-0.45,0.62-0.6s0.58-0.22,0.93-0.22c0.54,0,0.95,0.14,1.22,0.42
			c0.27,0.28,0.41,0.73,0.41,1.34v3.14H77.04z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M79.21,69.1c0-0.17,0.04-0.29,0.12-0.37s0.18-0.12,0.31-0.12c0.12,0,0.22,0.04,0.3,0.12s0.13,0.2,0.13,0.36
			s-0.04,0.29-0.13,0.37c-0.08,0.08-0.19,0.12-0.3,0.12c-0.12,0-0.23-0.04-0.31-0.12C79.25,69.39,79.21,69.26,79.21,69.1z M80,75.22
			h-0.73V70.4H80V75.22z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M83.48,75.31c-0.7,0-1.24-0.21-1.62-0.64c-0.38-0.43-0.57-1.04-0.57-1.82c0-0.81,0.19-1.43,0.58-1.87
			c0.39-0.44,0.94-0.66,1.66-0.66c0.23,0,0.46,0.02,0.69,0.07s0.41,0.11,0.54,0.18l-0.22,0.62c-0.16-0.06-0.34-0.12-0.53-0.16
			s-0.36-0.06-0.51-0.06c-0.98,0-1.47,0.62-1.47,1.87c0,0.59,0.12,1.05,0.36,1.36c0.24,0.32,0.59,0.47,1.06,0.47
			c0.4,0,0.81-0.09,1.23-0.26v0.65C84.37,75.22,83.96,75.31,83.48,75.31z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M91.28,73.91c0,0.45-0.17,0.79-0.5,1.04s-0.8,0.36-1.41,0.36c-0.64,0-1.14-0.1-1.49-0.3v-0.68
			c0.23,0.12,0.48,0.21,0.74,0.28c0.27,0.07,0.52,0.1,0.77,0.1c0.38,0,0.67-0.06,0.88-0.18s0.31-0.31,0.31-0.56
			c0-0.19-0.08-0.35-0.24-0.48c-0.16-0.13-0.48-0.29-0.95-0.47c-0.45-0.17-0.77-0.31-0.96-0.44c-0.19-0.12-0.33-0.27-0.42-0.42
			c-0.09-0.16-0.14-0.35-0.14-0.57c0-0.39,0.16-0.7,0.48-0.93s0.76-0.34,1.31-0.34c0.52,0,1.03,0.11,1.52,0.32l-0.26,0.59
			c-0.48-0.2-0.92-0.3-1.31-0.3c-0.35,0-0.61,0.05-0.78,0.16s-0.26,0.26-0.26,0.45c0,0.13,0.03,0.24,0.1,0.33
			c0.07,0.09,0.17,0.18,0.32,0.26s0.43,0.2,0.84,0.36c0.57,0.21,0.96,0.42,1.16,0.63C91.18,73.32,91.28,73.59,91.28,73.91z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M95.76,75.22V72.1c0-0.39-0.09-0.69-0.27-0.88s-0.46-0.29-0.84-0.29c-0.51,0-0.88,0.14-1.11,0.41
			c-0.23,0.28-0.35,0.73-0.35,1.35v2.52h-0.73v-6.84h0.73v2.07c0,0.25-0.01,0.46-0.04,0.62h0.04c0.14-0.23,0.35-0.41,0.61-0.55
			c0.26-0.13,0.57-0.2,0.91-0.2c0.59,0,1.03,0.14,1.33,0.42c0.29,0.28,0.44,0.72,0.44,1.33v3.14H95.76z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M102.15,72.81c0,0.79-0.2,1.4-0.59,1.84s-0.94,0.66-1.64,0.66c-0.43,0-0.81-0.1-1.15-0.3
			s-0.59-0.49-0.77-0.87s-0.27-0.82-0.27-1.33c0-0.79,0.2-1.4,0.59-1.83s0.94-0.66,1.63-0.66c0.67,0,1.21,0.22,1.61,0.67
			C101.95,71.44,102.15,72.04,102.15,72.81z M98.48,72.81c0,0.62,0.12,1.08,0.37,1.41s0.61,0.48,1.08,0.48s0.84-0.16,1.09-0.48
			c0.25-0.32,0.37-0.79,0.37-1.41c0-0.61-0.12-1.08-0.37-1.4c-0.25-0.32-0.61-0.48-1.1-0.48c-0.48,0-0.84,0.16-1.08,0.47
			S98.48,72.19,98.48,72.81z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M105.35,75.31c-0.7,0-1.24-0.21-1.62-0.64c-0.38-0.43-0.57-1.04-0.57-1.82c0-0.81,0.19-1.43,0.58-1.87
			c0.39-0.44,0.94-0.66,1.66-0.66c0.23,0,0.46,0.02,0.69,0.07s0.41,0.11,0.54,0.18l-0.22,0.62c-0.16-0.06-0.34-0.12-0.53-0.16
			s-0.36-0.06-0.51-0.06c-0.98,0-1.47,0.62-1.47,1.87c0,0.59,0.12,1.05,0.36,1.36c0.24,0.32,0.59,0.47,1.06,0.47
			c0.4,0,0.81-0.09,1.23-0.26v0.65C106.25,75.22,105.84,75.31,105.35,75.31z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M108.43,72.76c0.13-0.18,0.32-0.41,0.58-0.7l1.56-1.65h0.87l-1.95,2.05l2.09,2.76h-0.88l-1.7-2.28l-0.55,0.47
			v1.8h-0.72v-6.84h0.72v3.63c0,0.16-0.01,0.41-0.04,0.75H108.43z"
          />
          <path
      className={clsx(inView && classes.animation, classes.st1)}
            d="M115.54,73.91c0,0.45-0.17,0.79-0.5,1.04s-0.8,0.36-1.41,0.36c-0.64,0-1.14-0.1-1.49-0.3v-0.68
			c0.23,0.12,0.48,0.21,0.75,0.28c0.26,0.07,0.52,0.1,0.77,0.1c0.38,0,0.67-0.06,0.88-0.18s0.31-0.31,0.31-0.56
			c0-0.19-0.08-0.35-0.24-0.48c-0.16-0.13-0.48-0.29-0.95-0.47c-0.45-0.17-0.77-0.31-0.96-0.44c-0.19-0.12-0.33-0.27-0.42-0.42
			c-0.09-0.16-0.14-0.35-0.14-0.57c0-0.39,0.16-0.7,0.48-0.93s0.76-0.34,1.31-0.34c0.52,0,1.03,0.11,1.52,0.32l-0.26,0.59
			c-0.48-0.2-0.92-0.3-1.31-0.3c-0.35,0-0.61,0.05-0.78,0.16s-0.26,0.26-0.26,0.45c0,0.13,0.03,0.24,0.1,0.33
			c0.07,0.09,0.17,0.18,0.32,0.26s0.43,0.2,0.84,0.36c0.57,0.21,0.96,0.42,1.16,0.63C115.44,73.32,115.54,73.59,115.54,73.91z"
          />
        </g>
        <g>
          <path
            className={clsx(classes.st0)}
            d="M134.65,156.28c0.16,0.16,0.33,0.33,0.49,0.49l9.24-9.53L134.65,156.28z"
          />
          <path
            className={clsx(classes.st0)}
            d="M160.13,107.96c0-3.26,0.68-6.37,2-9.26l-39.59-22.86c-5.27,9.83-8.06,20.92-8.06,32.12
			c0,16.88,6.07,32.75,17.2,45.2l33.48-31.09C161.9,118.1,160.13,113.18,160.13,107.96z M138.15,105.68c0,0.43-0.37,0.79-0.82,0.79
			h-1.64c-0.45,0-0.82-0.35-0.82-0.79c0-0.43,0.37-0.79,0.82-0.79h1.64C137.79,104.9,138.15,105.25,138.15,105.68z M136.16,110.31
			c-0.32,0.31-0.84,0.31-1.16,0l-1.16-1.11c-0.32-0.31-0.32-0.8,0-1.11c0.32-0.31,0.84-0.31,1.16,0l1.16,1.11
			C136.48,109.51,136.48,110.01,136.16,110.31z M133.84,102.16l1.16-1.11c0.32-0.31,0.84-0.31,1.16,0c0.32,0.31,0.32,0.8,0,1.11
			l-1.16,1.11c-0.32,0.31-0.84,0.31-1.16,0C133.52,102.97,133.52,102.47,133.84,102.16z M130.51,99.92c0-0.43,0.37-0.79,0.82-0.79
			c0.45,0,0.82,0.35,0.82,0.79v1.57c0,0.43-0.37,0.79-0.82,0.79c-0.45,0-0.82-0.35-0.82-0.79V99.92z M131.33,103.33
			c1.36,0,2.46,1.05,2.46,2.36c0,1.3-1.1,2.36-2.46,2.36s-2.46-1.06-2.46-2.36C128.87,104.38,129.97,103.33,131.33,103.33z
			 M132.15,109.87v1.57c0,0.43-0.37,0.79-0.82,0.79c-0.45,0-0.82-0.35-0.82-0.79v-1.57c0-0.43,0.37-0.79,0.82-0.79
			C131.78,109.09,132.15,109.44,132.15,109.87z M128.82,109.2l-1.16,1.11c-0.32,0.31-0.84,0.31-1.16,0c-0.32-0.31-0.32-0.8,0-1.11
			l1.16-1.11c0.32-0.31,0.84-0.31,1.16,0C129.14,108.4,129.14,108.9,128.82,109.2z M126.5,101.05c0.32-0.31,0.84-0.31,1.16,0
			l1.16,1.11c0.32,0.31,0.32,0.8,0,1.11c-0.32,0.31-0.84,0.31-1.16,0l-1.16-1.11C126.19,101.86,126.19,101.36,126.5,101.05z
			 M125.33,104.9h1.64c0.45,0,0.82,0.35,0.82,0.79c0,0.43-0.37,0.79-0.82,0.79h-1.64c-0.45,0-0.82-0.35-0.82-0.79
			C124.5,105.25,124.87,104.9,125.33,104.9z M147.98,109.59c0-1.14-0.97-2.07-2.16-2.07c-1.19,0-2.21,0.93-2.21,2.07v12.08h5.73
			c0.75,0,1.36,0.59,1.36,1.31c0,0.72-0.61,1.31-1.36,1.31h-23.47c-0.75,0-1.37-0.59-1.37-1.31c0-0.72,0.61-1.31,1.37-1.31h16.1
			v-7.86h-1.36c-0.75,0-1.37,0.59-1.37,1.31v0.62c0.65,0.3,1.09,0.92,1.09,1.65c0,0.92-1.56,2.85-1.86,3.21
			c-0.02,0.03-0.07,0.03-0.1,0c-0.3-0.36-1.86-2.29-1.86-3.21c0-0.73,0.45-1.35,1.09-1.65v-0.62c0-0.09,0-0.18,0.02-0.26
			c0.09-1.01,0.73-1.86,1.62-2.29c0.33-0.17,0.7-0.27,1.09-0.31c0.09-0.01,0.18-0.01,0.27-0.01h1.36v-2.65
			c0-2.01,1.75-3.64,3.84-3.64c2.09,0,3.8,1.64,3.8,3.64c0,0.01,0,0.02,0,0.03h0v0.36c0.64,0.29,1.09,0.92,1.09,1.65
			c0,0.92-1.57,2.85-1.86,3.21c-0.03,0.03-0.07,0.03-0.1,0c-0.3-0.36-1.86-2.29-1.86-3.21c0-0.73,0.45-1.35,1.09-1.65v-0.36h0
			C147.98,109.6,147.98,109.6,147.98,109.59z"
          />
          <g>
            <path
              className={clsx(classes.st0)}
              d="M168.85,71.03c-0.57,0-1.04,0.47-1.04,1.04c0,0.57,0.47,1.04,1.04,1.04c0.57,0,1.04-0.47,1.04-1.04
				C169.89,71.49,169.42,71.03,168.85,71.03z"
            />
            <path
              className={clsx(classes.st0)}
              d="M155.32,71.03c-0.57,0-1.04,0.47-1.04,1.04c0,0.57,0.47,1.04,1.04,1.04c0.57,0,1.04-0.47,1.04-1.04
				C156.36,71.49,155.89,71.03,155.32,71.03z"
            />
            <path
              className={clsx(classes.st0)}
              d="M124.71,72.11l39.59,22.86c4.11-5.73,10.7-9.23,17.83-9.33V39.99C158.66,40.1,137.01,52.3,124.71,72.11z
				 M149.67,66.56c-0.15,0-0.31-0.06-0.42-0.18c-0.22-0.23-0.2-0.59,0.03-0.81l10.18-9.51l3.92,4.89l7.52-6.27l-4.79-0.26
				c-0.32-0.02-0.56-0.29-0.54-0.6c0.02-0.31,0.26-0.57,0.6-0.54l6.26,0.34c0,0,0.01,0,0.01,0l0.59,0.03l-0.87,6.82
				c-0.04,0.29-0.28,0.5-0.57,0.5c-0.02,0-0.05,0-0.07-0.01c-0.31-0.04-0.54-0.33-0.5-0.64l0.61-4.77l-8.42,7.02l-3.87-4.84
				l-9.28,8.66C149.95,66.51,149.81,66.56,149.67,66.56z M171.97,76.3c0,0.25-0.2,0.45-0.44,0.45h-18.89c-0.24,0-0.44-0.2-0.44-0.45
				v-8.47c0-0.24,0.2-0.44,0.44-0.44h18.89c0.25,0,0.44,0.2,0.44,0.44V76.3z M174.57,73.7c0,0.24-0.2,0.44-0.44,0.44h-1.12v-7.31
				c0-0.27-0.22-0.49-0.5-0.49H154.8v-1.11c0-0.25,0.2-0.45,0.44-0.45h18.89c0.24,0,0.44,0.2,0.44,0.45V73.7z"
            />
            <path
              className={clsx(classes.st0)}
              d="M162.09,68.94c-1.72,0-3.12,1.4-3.12,3.12s1.4,3.12,3.12,3.12c1.72,0,3.12-1.4,3.12-3.12
				S163.81,68.94,162.09,68.94z"
            />
          </g>
          <path
            className={clsx(classes.st0)}
            d="M186.44,40.1v45.89c10.42,1.88,18.35,11.01,18.35,21.97c0,12.31-10.02,22.33-22.33,22.33
			c-5.26,0-10.27-1.82-14.27-5.16l-23.8,22.1l-9.25,9.54c12.75,12.36,29.55,19.17,47.32,19.17c37.48,0,67.98-30.49,67.98-67.98
			C250.44,71.81,222.08,42.17,186.44,40.1z M223.16,98.5c0-0.96,0.79-1.75,1.75-1.75s1.75,0.79,1.75,1.75v6.19
			c0,0.96-0.79,1.75-1.75,1.75s-1.75-0.79-1.75-1.75V98.5z M220.97,117.91l-5.8,5.8c-0.68,0.68-1.79,0.68-2.47,0
			c-0.68-0.68-0.68-1.79,0-2.47l5.8-5.8c0.68-0.68,1.79-0.68,2.47,0C221.65,116.11,221.65,117.23,220.97,117.91z M212.37,111.66
			c0-0.96,0.79-1.75,1.75-1.75h3.72c0.96,0,1.75,0.79,1.75,1.75c0,0.96-0.79,1.75-1.75,1.75h-3.72
			C213.16,113.41,212.37,112.63,212.37,111.66z M221,107.81c-0.68,0.68-1.79,0.68-2.47,0l-7.88-7.88c-0.68-0.68-0.68-1.79,0-2.47
			c0.68-0.68,1.79-0.68,2.47,0l7.88,7.88C221.68,106.02,221.68,107.13,221,107.81z M226.66,124.92c0,0.96-0.79,1.75-1.75,1.75
			s-1.75-0.79-1.75-1.75v-6.19c0-0.96,0.79-1.75,1.75-1.75s1.75,0.79,1.75,1.75V124.92z M225,114.7c-1.66,0-3.01-1.35-3.01-3.02
			c0-1.66,1.35-3.01,3.01-3.01s3.01,1.35,3.01,3.01C228.01,113.35,226.66,114.7,225,114.7z M228.66,105.42l1.74-1.74
			c0.68-0.68,1.79-0.68,2.47,0c0.68,0.68,0.68,1.79,0,2.47l-1.74,1.74c-0.68,0.68-1.79,0.68-2.47,0
			C227.98,107.21,227.98,106.1,228.66,105.42z M234.44,121.14c-0.68,0.68-1.79,0.68-2.47,0l-3.23-3.23c-0.68-0.68-0.68-1.79,0-2.47
			c0.68-0.68,1.79-0.68,2.47,0l3.23,3.23C235.12,119.34,235.12,120.46,234.44,121.14z M238,113.49h-5.91
			c-0.96,0-1.75-0.79-1.75-1.75c0-0.96,0.79-1.75,1.75-1.75H238c0.96,0,1.75,0.79,1.75,1.75C239.75,112.7,238.96,113.49,238,113.49z
			"
          />
          <path className={clsx(classes.st0)} d="M234.81,75.23" />
        </g>
        <line className={classes.st2} x1="221.81" y1="74.52" x2="256.16" y2="74.52" />
        <path className={classes.st3} d="M257.65,74.52L257.65,74.52 M218.83,74.52L218.83,74.52" />
        <g>
          <path
            className={classes.st0}
            d="M257.65,76.52c1.1,0,2-0.9,2-2c0-1.1-0.9-2-2-2c-1.11,0-2,0.9-2,2C255.65,75.62,256.55,76.52,257.65,76.52"
          />
        </g>
        <line className={classes.st4} x1="119.21" y1="110.11" x2="105.55" y2="110.11" />
        <path
          className={classes.st3}
          d="M104.03,110.11L104.03,110.11 M122.24,110.11L122.24,110.11"
        />
        <g>
          <path
            className={classes.st0}
            d="M104.03,112.11c-1.11,0-2-0.9-2-2c0-1.1,0.89-2,2-2c1.1,0,2,0.9,2,2
			C106.03,111.22,105.13,112.11,104.03,112.11"
          />
        </g>
        <line className={classes.st5} x1="147.87" y1="56.28" x2="147.87" y2="33.77" />
        <line className={classes.st6} x1="144.71" y1="32.27" x2="124.19" y2="32.27" />
        <path
          className={classes.st3}
          d="M122.61,32.27L122.61,32.27 M147.87,32.27L147.87,32.27 M147.87,59.28L147.87,59.28"
        />
        <g>
          <path
            className={classes.st0}
            d="M122.61,34.27c-1.11,0-2-0.9-2-2c0-1.1,0.89-2,2-2c1.1,0,2,0.9,2,2C124.61,33.37,123.72,34.27,122.61,34.27"
          />
        </g>
      </g>
    </svg>
  );
};

export default DriversOfHunger;
